import { data } from 'autoprefixer';
import axios from 'axios';
import { get } from 'lodash';

//import axios from './http-common1';
class DataService {
  //new Routes api for new client panel 29-11-2022
  getSideFilterData() {
    return axios.get('/default/sidefilterdata');
  }
  ValidateSession() {
    return axios.get('/validsession');
  }

  //1. Front Route Functions
  GetSideCategoryData() {
    return axios.get('/getSideCategoryData');
  }
  getAllDomain() {
    return axios.get('/getActiveDomain');
  }

  getSectorName(sector_id) {
    return axios.get(`/getSectorName/${sector_id}`);
  }

  getCategoryName(category_id) {
    return axios.get(`/getCategoryName/${category_id}`);
  }

  getSkillName(skill_ids) {
    return axios.get(`/getSkillName/${skill_ids}`);
  }

  getAllCategory() {
    return axios.get('/getAllCategory');
  }

  getHireCandidate(data, page) {
    return axios.post(`/getHireCandidate?page=${page}`, data);
  }
  getHireEarnLearnData(category_id) {
    return axios.get(`/getHireEarnLearnData/${category_id}`);
  }
  getLoadMoreHireCandidate(data) {
    return axios.post(`/getHireCandidateMore`, data);
  }

  geteHiretabdata(data, childtype, pagesize, page) {
    return axios.post(
      `/gethiretabdata?page=${page}&childtype=${childtype}&pagesize=${pagesize}`,
      data
    );
  }

  //new
  geteHirepagedata(data, childtype, pagesize, page) {
    return axios.post(
      `/gethirepagedata?page=${page}&childtype=${childtype}&pagesize=${pagesize}`,
      data
    );
  }
  getuserfordrawer(data) {
    return axios.post(`/getuserfordrawer`, data);
  }
  geteEarntabdata(data, childtype, pagesize, page) {
    return axios.post(
      `/getearntabdata?page=${page}&childtype=${childtype}&pagesize=${pagesize}`,
      data
    );
  }
  geteEarnpagedata(data, childtype, pagesize, page) {
    return axios.post(
      `/getearnpagedata?page=${page}&childtype=${childtype}&pagesize=${pagesize}`,
      data
    );
  }
  geteLearntabdata(data, childtype, pagesize, page) {
    return axios.post(
      `/getlearntabdata?page=${page}&childtype=${childtype}&pagesize=${pagesize}`,
      data
    );
  }

  geteLearnpagedata(data, childtype, pagesize, page) {
    return axios.post(
      `/getlearnpagedata?page=${page}&childtype=${childtype}&pagesize=${pagesize}`,
      data
    );
  }
  payoutReportCRM(
    fromDate,
    toDate,
    page,
    pagesize,
    selectedPayType,
    selectedstatus,
    transferredToWallet,
    selectedDateType,
    key
  ) {
    return axios.get(
      `/admin/crm/payout_report/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&selectedPayType=${selectedPayType}&selectedstatus=${selectedstatus}&transferredToWallet=${transferredToWallet}&date_type=${selectedDateType}&keyword=${key}`
    );
  }

  getcategory(domainid) {
    return axios.get(`/getcategory/${domainid}`);
  }

  GetSearchSuggestion(data) {
    return axios.post('/getSearchTags', data);
  }

  getFrontSearchCatlog(pageType, selectedtag, page) {
    return axios.get(`/getFrontSearchCatlog/${pageType}/${selectedtag}?page=${page}`);
  }

  getFilterSearchCatlog(
    pageType,
    searchTag,
    price,
    delivery_time,
    user_level,
    class_type,
    rating_value,
    page
  ) {
    return axios.get(
      `/getbyFilterFrontSearchCatlog/${pageType}/${searchTag}/${price}/${delivery_time}/${user_level}/${class_type}/${rating_value}?page=${page}`
    );
  }

  GetRatingTotals(data) {
    return axios.post('/getRatingTotals', data);
  }

  gettoken() {
    return axios.get('/sanctum/csrf-cookie');
  }
  appBootstrap() {
    return axios.get('/app/bootstrap');
  }
  login(data) {
    return axios.post('/userlogin', data);
  }
  adminlogin(data) {
    return axios.post('/admin/adminlogin', data);
  }
  accountlogin(data) {
    return axios.post('/admin/accountlogin', data);
  }

  register(data) {
    return axios.post('/register', data);
  }
  accountregister(data) {
    return axios.post('/accountregister', data);
  }
  logout() {
    return axios.post('/logout', null);
  }
  forgetPassoword(data) {
    return axios.post('/forgetpassword', data);
  }
  changePassword(data) {
    return axios.post('/changepassword', data);
  }
  changeAuthPassword(data) {
    return axios.post('/changeauthpassword', data);
  }
  emailtestunique(data) {
    return axios.post('/emailtestunique', data);
  }

  getDomainMenu() {
    return axios.get('/getdomainmenu');
  }
  getProposal(domainid, categoryid) {
    return axios.get(`/getproposal/${domainid}/${categoryid}`);
  }
  getProjectalldata(domainid, categoryid) {
    return axios.get(`/getprojectalldata/${domainid}/${categoryid}`);
  }

  GetWorkForUser(domainid, categoryid, type) {
    return axios.get(`/getworkforuser/${categoryid}/${domainid}/${type}`);
  }

  // findjobgetworkforUser(domainid,categoryid,type,project_level,project_ratetype,price)
  findjobgetworkforUser(page, data, search) {
    return axios.post(`/findjobgetworkforUser?page=${page}&search=${search}`, data);
    //     return axios.get(`/findjobgetworkforUser/${domainid}/${categoryid}/${type}/${project_level}/${project_ratetype}/${price}`);
  }

  FilterSavedJobs(page, data) {
    return axios.get(`/filterSavedJobs?page=${page}&key=${data}`);
  }

  FilterInvitedJobs(page, data) {
    return axios.get(`/filterInvitedJobs?page=${page}&key=${data}`);
  }

  Proposalsubmit(page, data) {
    return axios.get(`/proposalsubmit?page=${page}&key=${data}`);
  }

  mobileVarification(data) {
    return axios.post(`/account/mobile/varification`, data);
  }
  sendOtpBySms(mobile) {
    return axios.post(`/account/mobile/sendsms/${mobile}`);
  }
  otpVarification(data) {
    return axios.post(`/account/mobile/otp/varification`, data);
  }

  hiredproposal(page, data) {
    return axios.get(`/hiredproposal?page=${page}&key=${data}`);
  }

  SearchWorkForUser(data) {
    return axios.post(`/searchWork`, data);
  }

  SavedJobs(project_type, domain_id) {
    return axios.get(`/savedJobs/${project_type}/${domain_id}`);
  }

  SearchSavedJobForUser(data) {
    return axios.post(`/searchSavedJobs`, data);
  }

  SearchproposalsubmitForUser(page, pagesize, keyword) {
    return axios.get(
      `/SearchproposalsubmitForUser?page=${page}&pagesize=${pagesize}&keyword=${keyword}`
    );
  }

  Searchhiredproposal(data) {
    return axios.post(`/SearchhiredproposalForUser`, data);
  }

  InvitedJobs(project_type, domain_id) {
    return axios.get(`/invited/${project_type}/${domain_id}`);
  }

  SearchInvitedJobForUser(data) {
    return axios.post(`/searchInvitedJobs`, data);
  }

  SearchMyHiredUser(data) {
    return axios.post(`/seller/project/searchMyHired`, data);
  }

  SearchMyHire(data) {
    return axios.post(`/seller/project/searchMyHire`, data);
  }

  SearchSavedTalents(data) {
    return axios.post(`/seller/project/searchSavedTalents`, data);
  }

  Confirmpayment(data) {
    return axios.post(`confirmpayment`, data);
  }

  ConfirmPlanPayment(data) {
    return axios.post(`/confirm_plan_payment`, data);
  }

  proposalDetail(proposal_id) {
    return axios.get(`/proposaldetail/${proposal_id}`);
  }

  courseDetail(class_id) {
    return axios.get(`/coursedetail/${class_id}`);
  }

  GetLectureById(id) {
    return axios.get(`/getLectureById/${id}`);
  }

  SendMsgToSeller(data) {
    return axios.post('/sentMsgtoSeller', data);
  }
  projectfrontdetail(proposal_id) {
    return axios.get(`/projectfrontdetail/${proposal_id}`);
  }

  featuredProposalDetail() {
    return axios.get('/getFeaturedProposal');
  }
  userproposalallData(user_id) {
    return axios.get(`/userproposalalldata/${user_id}`);
  }
  createcart(data) {
    return axios.post(`/addToCart`, data);
  }
  getCartdata() {
    return axios.get('/getCartdata');
  }

  checkoutcartdata(buyer_id) {
    return axios.get(`/checkoutcartdata/${buyer_id}`);
  }

  Makepayment(data) {
    return axios.post(`/Makepayment`, data);
  }
  Orderstore(data) {
    return axios.post(`/orderstore`, data);
  }

  PurchasePlan(data) {
    return axios.post(`/purchase_plan`, data);
  }

  deletecart(cart_id) {
    return axios.delete(`/deletecart/${cart_id}`);
  }

  getonlyDomainMenu() {
    return axios.get('/getonlydomainmenu');
  }

  getCategoryMenu() {
    return axios.get('/admin/category/getcategoriesmenu');
  }

  //2. Front Route Functions
  getSliderimage() {
    return axios.get('/getslider');
  }

  //3. Front Route Functions

  getserviceCard() {
    return axios.get('/getservicecard');
  }

  getAllBottominfo() {
    return axios.get(`/getActivebottominfo`);
  }

  getPortfoliobyUserandCatid(userId, categoryId) {
    return axios.get(`/getPortfoliobycategory/${userId}/${categoryId}`);
  }

  previewPortfolio(portfolioId) {
    return axios.get(`/getPortfolioforPreview/${portfolioId}`);
  }

  getProjects() {
    return axios.get('/getAuthUserProjects');
  }
  getSideFilterData() {
    return axios.get('/default/sidefilterdata');
  }

  MyHires(page, key) {
    return axios.get(`/seller/project/myhires?page=${page}&keyword=${key}`);
    // return axios.post(`/seller/project/myhires`,data);
  }

  GetInvitedTalents(category_id) {
    return axios.get(`/seller/project/getSavedTalents/${category_id}`);
  }

  GetSavedTalents(page, key = '') {
    return axios.get(`/getsavedUsers?page=${page}&keyword=${key}`);
    // return axios.get(`/getsavedUsers/${domain_id}/${user_level}/${hourly_rate}`);
  }

  getProceesingFee() {
    return axios.get('/getProcessingFee');
  }

  // End Front Route Functions

  //2. Admin Route Functions
  getDomain(page, pagesize, search = '') {
    return axios.get(`/admin/domain?page=${page}&pagesize=${pagesize}&search=${search}`);
  }
  metaTageDomainReport(page, pagesize, sector_id) {
    return axios.get(`/admin/domain/metatags/${sector_id}?page=${page}&pagesize=${pagesize}`);
  }
  metaTageCategoryReport(page, pagesize, category_id) {
    return axios.get(
      `/admin/domain/category/metatags/${category_id}?page=${page}&pagesize=${pagesize}`
    );
  }
  faqMasterSector(page, pagesize, faq_id) {
    return axios.get(`/admin/domain/faq/get/${faq_id}?page=${page}&pagesize=${pagesize}`);
  }

  faqMasterSectorCategory(page, pagesize, faq_id) {
    return axios.get(`/admin/domain/category/faq/get/${faq_id}?page=${page}&pagesize=${pagesize}`);
  }
  getAllCitySector(type) {
    return axios.get(`/admin/domain/pagedesign/sector/city_master/get/${type}`);
  }
  getAllCategorySectorDesignPage() {
    return axios.get(`/admin/domain/pagedesign/sector/category_master/get`);
  }
  pageDesigndata(sector_id) {
    return axios.get(`/admin/domain/pagedesign/get/${sector_id}`);
  }
  categoryDesigndataReport(cat_id) {
    return axios.get(`/admin/domain/pagedesign/category/get/${cat_id}`);
  }
  CategoryPageDesignReplaceWord(data) {
    return axios.post(`/admin/domain/pagedesign/category/replace_word`, data);
  }
  categorydesigndata(sector_id) {
    return axios.get(`/admin/domain/pagedesign/getcategory/${sector_id}`);
  }
  sectorPageDesignCitiesStatus(id) {
    return axios.get(`/admin/domain/pagedesign/city/status/${id}`);
  }
  sectorPageDesignCities(page, pagesize, search) {
    return axios.get(
      `/admin/domain/pagedesign/city/get?page=${page}&pagesize=${pagesize}&search_key=${search}`
    );
  }
  sectorPageDesignCitiesPost(data) {
    return axios.post('/admin/domain/pagedesign/city/store', data);
  }
  pageDesigndataReportAll(sector_id) {
    return axios.get(`/admin/domain/pagedesign/get/data/${sector_id}`);
  }
  getcitypagedesign(page, pagesize) {
    return axios.get(`/admin/city/pagedesign/get?page=${page}&pagesize=${pagesize}`);
  }
  getNewCityPageDesign(city_id, page, pagesize) {
    return axios.get(
      `/admin/city/newpagedesign/get/data/${city_id}?page=${page}&pagesize=${pagesize}`
    );
  }
  getCityName(city_id) {
    return axios.get(`/admin/city/newpagedesign/fetch/cityname/${city_id}`);
  }
  getCityCategories(id) {
    return axios.get(`/admin/city/newpagedesign/create/${id}`);
  }
  saveCityPageDesign(data) {
    return axios.post(`/admin/city/newpagedesign/store`, data);
  }
  fetchCityPageDesignData(id) {
    return axios.get(`/admin/city/newpagedesign/edit/${id}`);
  }
  UpdateCityPageDesign(data) {
    return axios.post(`/admin/city/newpagedesign/update`, data);
  }
  GetCityandCategory() {
    return axios.get(`/admin/city/pagedesign/all`);
  }

  GlobalMetaGroupReport(page, pagesize, search) {
    return axios.get(
      `/admin/globalmeta/report?page=${page}&pagesize=${pagesize}&search_key=${search}`
    );
  }

  GlobalMetaGroupStore(data) {
    return axios.post(`/admin/globalmeta/store`, data);
  }
  GlobalMetaGroupDelete(id) {
    return axios.get(`/admin/globalmeta/delete/${id}`);
  }

  GlobalMetaDetailReport(id, page, pagesize, search = '') {
    return axios.get(
      `/admin/globalmetadetail/report/${id}?page=${page}&pagesize=${pagesize}&search_key=${search}`
    );
  }

  GlobalMetaDetailStore(data) {
    return axios.post(`/admin/globalmetadetail/store`, data);
  }
  GlobalMetaDetailDelete(id) {
    return axios.get(`/admin/globalmetadetail/delete/${id}`);
  }
  GlobalMetaMasterGet() {
    return axios.get(`/admin/globalmetadetail/global_met_master/get`);
  }

  GetCategorybyDomain(data) {
    return axios.post(`/admin/city/pagedesign/category`, data);
  }
  SaveCityPage(data) {
    return axios.post(`/admin/city/pagedesign/citypage/save`, data);
  }
  GetSelectedData(id) {
    return axios.get(`/admin/city/pagedesign/citypage/fetch/${id}`);
  }
  getcitydesigndata(id) {
    return axios.get(`/admin/city/pagedesign/edit/${id}`);
  }
  DeactivateCityDesign(id) {
    return axios.get(`/admin/city/pagedesign/deactivate/${id}`);
  }
  DeactivateSectorPageDesign(id) {
    return axios.get(`/admin/domain/pagedesign/deactivate/${id}`);
  }
  DeactivateCategoryPageDesign(id) {
    return axios.get(`/admin/domain/pagedesign/category/deactivate/${id}`);
  }
  createcitypagedesign(data) {
    return axios.post(`/admin/city/pagedesign/store`, data);
  }

  whatsAppEventReport(page, pagesize, search_event = '') {
    return axios.get(
      `/admin/whatsapp_event/report?page=${page}&pagesize=${pagesize}&search_key=${search_event}`
    );
  }
  whatsAppEventStore(data) {
    return axios.post(`/admin/whatsapp_event/save`, data);
  }
  whatsAppEventStatusUpdate(id) {
    return axios.get(`/admin/whatsapp_event/status_update/${id}`);
  }

  CityFaqReport(id, page, pagesize) {
    return axios.get(`/admin/city/pagedesign/faq/get/${id}?page=${page}&pagesize=${pagesize}`);
  }

  CitypageMasterMetaReport(id, page, pagesize) {
    return axios.get(`/admin/city/pagedesign/meta_tag/get/${id}?page=${page}&pagesize=${pagesize}`);
  }

  StoreCityPageDesignMeta(data) {
    return axios.post(`/admin/city/pagedesign/meta_tag/store`, data);
  }

  CityFaqEdit(id) {
    return axios.get(`/admin/city/pagedesign/faq/edit/${id}`);
  }
  DeactivateCityFaq(id) {
    return axios.get(`/admin/city/pagedesign/faq/deactivate/${id}`);
  }
  StoreCityFaq(data) {
    return axios.post(`/admin/city/pagedesign/faq/store`, data);
  }

  deletepagedesigndata(id) {
    return axios.get(`/admin/domain/pagedesign/data/delete/${id}`);
  }

  deletecategorypagedesigndata(id) {
    return axios.get(`/admin/domain/pagedesign/data/deletecategory/${id}`);
  }

  changecolumnstatus(data) {
    return axios.post(`/admin/domain/pagedesign/data/status`, data);
  }
  changecategorypagestatus(data) {
    return axios.post(`/admin/domain/pagedesign/data/substatus`, data);
  }

  pagedesigndataupdate(data) {
    return axios.post('/admin/domain/pagedesign/data/update', data);
  }
  SectorPageDesignStore(data) {
    return axios.post('/admin/domain/pagedesign/store', data);
  }
  GlobalPageDesignStore(data) {
    return axios.post('/admin/master/global_alt/store', data);
  }

  getGlobalAlt() {
    return axios.get('/admin/master/global_alt/get');
  }

  CategoryPageDesignStore(data) {
    return axios.post('/admin/domain/pagedesign/category/store', data);
  }
  SectorPageDesignUpdate(data) {
    return axios.post('/admin/domain/pagedesign/update', data);
  }
  getsectiondata(page, pagesize, section_id, type) {
    return axios.get(
      `/admin/domain/pagedesign/section/get/${section_id}/${type}?page=${page}&pagesize=${pagesize}`
    );
  }
  getsectionassestdata(page, pagesize, section_id, type) {
    return axios.get(
      `/admin/domain/pagedesign/section_assets/get/${section_id}/${type}?page=${page}&pagesize=${pagesize}`
    );
  }
  SectionAssetsDelete(id) {
    return axios.get(`/admin/domain/pagedesign/section_assets/delete/${id}`);
  }
  SectiondataStore(data) {
    return axios.post('/admin/domain/pagedesign/section/store', data);
  }
  SectionassetdataStore(data) {
    return axios.post('/admin/domain/pagedesign/section_assets/store', data);
  }
  Sectionstatus(id) {
    return axios.get(`/admin/domain/pagedesign/section/status/${id}`);
  }
  metaTageDomainStore(data) {
    return axios.post('/admin/domain/metatags/store', data);
  }
  faqMastereSectorStore(data) {
    return axios.post('/admin/domain/faq/store', data);
  }
  metaTageDomainStatus(id) {
    return axios.get(`/admin/domain/metatags/status/${id}`);
  }
  faqMastereSectorStatus(id) {
    return axios.get(`/admin/domain/faq/status/${id}`);
  }
  getAllDomain() {
    return axios.get(`/admin/domain/getActiveDomain`);
  }
  getDomainByID(id) {
    return axios.get(`/admin/domain/edit/${id}`);
  }
  createDomain(data) {
    return axios.post('/admin/domain/add', data);
  }
  updateDomain(id, data) {
    return axios.post(`/admin/domain/update/${id}`, data);
  }
  DomainActiveStatusToggle(id) {
    return axios.post(`/admin/domain/deactivate/${id}`);
  }
  DomainActiveStatus(id) {
    return axios.post(`/admin/category/deactivatedata/${id}`);
  }
  deleteDomain(id) {
    return axios.delete(`/admin/domain/delete/${id}`);
  }

  DomainFeatureUnfeature(id) {
    return axios.post(`/admin/domain/domainFeatureUnfeature/${id}`);
  }
  SearchuserData(data, page, pagesize) {
    return axios.post(`/admin/search?page=${page}&pagesize=${pagesize}`, data);
  }

  //user report
  bidByUser(id, type, page, pagesize, key) {
    return axios.get(
      `/admin/user_report/bid/get/${id}/${type}?page=${page}&pagesize=${pagesize}&keyword=${key}`
    );
  }
  getClientProjectReport(id, type, page, pagesize, key) {
    return axios.get(
      `/admin/user_report/project/get/${id}/${type}?page=${page}&pagesize=${pagesize}&keyword=${key}`
    );
  }

  // getProjectDetails(id,type,page,pagesize,key){
  //     return axios.get(`/admin/project_report/details/${id}/${type}?page=${page}&pagesize=${pagesize}&keyword=${key}`);

  // }
  //projects bids

  projectBids(id, filter, page, pagesize, project, key) {
    return axios.get(
      `/admin/project_report/bid/get/${id}/${filter}?page=${page}&pagesize=${pagesize}&project=${project}&keyword=${key}`
    );
  }

  getFreelancerByProjectCategory(id, cat, page, key) {
    return axios.get(
      `/admin/project_report/change/freelancer/get/${id}?cat=${cat}&page=${page}&key=${key}`
    );
  }
  ChangeFreelancerOfProject(data) {
    return axios.post(`/admin/project_report/change/freelancer/update`, data);
  }
  ChangeProjectStatus(data) {
    return axios.post(`/admin/project_report/change/status/update`, data);
  }

  zoopbuysubreport(id, filter, page, pagesize, project, key) {
    return axios.get(
      `/admin/zoop_buy/subreport/get/${id}/${filter}?page=${page}&pagesize=${pagesize}&project=${project}&keyword=${key}`
    );
  }

  // 2. functions for Category

  getAllSubcategory() {
    return axios.get(`/admin/getSubcategory`);
  }
  getAllUserSubcategory() {
    return axios.get(`/admin/getuserSubcategory`);
  }
  getprojectAllSubcategory() {
    return axios.get(`/admin/getprojectSubcategory`);
  }

  getCategory(page) {
    return axios.get(`/admin/category?page=${page}`);
  }
  getCategoryfilter(id, page, pagesize, search = '') {
    return axios.get(
      `/admin/filtercategory/${id}?page=${page}&pagesize=${pagesize}&search=${search}`
    );
  }
  getCategoryById(id) {
    return axios.get(`/admin/category/edit/${id}`);
  }

  getOrderById(id) {
    return axios.get(`/admin/category/get_order/${id}`);
  }

  createCategory(data) {
    return axios.post('/admin/category/add', data);
  }
  updateCategory(id, data) {
    return axios.post(`/admin/category/update/${id}`, data);
  }
  CategoryActiveStatusToggle(id) {
    return axios.post(`/admin/category/deactivate/${id}`);
  }

  deleteCategory(id) {
    return axios.delete(`/admin/category/delete/${id}`);
  }

  CategoryFeatureUnfeature(id) {
    return axios.post(`/admin/category/categoryFeatureUnfeature/${id}`);
  }

  // 3. functions for Skill

  getSkill(page, pagesize) {
    return axios.get(`/admin/skill?page=${page}&pagesize=${pagesize}`);
  }
  getActiveSkills() {
    return axios.get(`/admin/skill/activeskill`);
  }

  getSkillByUser(data) {
    return axios.post('/admin/skill/byUserCat', data);
  }

  createSkill(data) {
    return axios.post('/admin/skill/add', data);
  }

  getSkillById(id) {
    return axios.get(`/admin/skill/edit/${id}`);
  }

  updateSkill(id, data) {
    return axios.post(`/admin/skill/update/${id}`, data);
  }
  SkillActiveStatusToggle(id) {
    return axios.post(`/admin/skill/deactivate/${id}`);
  }
  deleteSkill(id) {
    return axios.delete(`/admin/skill/delete/${id}`);
  }

  // 4. functions for HelperTYpe

  getActiveHelperType() {
    return axios.get(`/admin/helper_type/getActiveHelperType`);
  }

  getHelperType(page, pagesize) {
    return axios.get(`/admin/helper_type?page=${page}&pagesize=${pagesize}`);
  }
  createHelperType(data) {
    return axios.post('/admin/helper_type/add', data);
  }

  getHelperTypeById(id) {
    return axios.get(`/admin/helper_type/edit/${id}`);
  }

  updateHelperType(id, data) {
    return axios.post(`/admin/helper_type/update/${id}`, data);
  }
  HelperTypeActiveStatusToggle(id) {
    return axios.post(`/admin/helper_type/deactivate/${id}`);
  }
  deleteHelperType(id) {
    return axios.delete(`/admin/helper_type/delete/${id}`);
  }

  // 5. functions for HelperTYpe

  getHelperMaster(page, pagesize) {
    return axios.get(`/admin/helper_master?page=${page}&pagesize=${pagesize}`);
  }
  createHelperMaster(data) {
    return axios.post('/admin/helper_master/add', data);
  }

  getHelperMasterById(id) {
    return axios.get(`/admin/helper_master/edit/${id}`);
  }

  updateHelperMaster(id, data) {
    return axios.post(`/admin/helper_master/update/${id}`, data);
  }
  HelperMasterActiveStatusToggle(id) {
    return axios.post(`/admin/helper_master/deactivate/${id}`);
  }
  deleteHelperMaster(id) {
    return axios.delete(`/admin/helper_master/delete/${id}`);
  }

  // 6. functions for DeliveryMaster

  getDeliveryMaster(page, pagesize) {
    return axios.get(`/admin/delivery_time?page=${page}&pagesize=${pagesize}`);
  }

  createDeliveryTime(data) {
    return axios.post(`/admin/delivery_time/add`, data);
  }

  getDeliveryTimeById(id) {
    return axios.get(`/admin/delivery_time/edit/${id}`);
  }
  getActiveDeliveryTime() {
    return axios.get(`/admin/delivery_time/getActiveDeliveryTime`);
  }
  updateDeliveryTime(id, data) {
    return axios.post(`/admin/delivery_time/update/${id}`, data);
  }
  DeliveryTimeActiveStatusToggle(id) {
    return axios.post(`/admin/delivery_time/deactivate/${id}`);
  }
  deleteDeliveryTime(id) {
    return axios.delete(`/admin/delivery_time/delete/${id}`);
  }

  // 7. functions for UsersReport
  getSubscribers(fromDate, toDate, page, pagesize, keyword) {
    return axios.get(
      `/admin/getSubscribers/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&skey=${keyword}`
    );
  }

  LeadAnalyticget(fromDate, toDate) {
    return axios.get(`/admin/crm/leadanalytics?fromDate=${fromDate}&toDate=${toDate}`);
  }

  filterSubscriber(data, page) {
    return axios.post(`/admin/users/filterallsubscriber?page=${page}`, data);
  }

  getUsers(
    tabtype,
    usertype,
    fromDate,
    toDate,
    page,
    pagesize,
    cat,
    keyword,
    status,
    gstStatus,
    panStatus
  ) {
    return axios.get(
      `/admin/users/${tabtype}/${usertype}/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&cat=${cat}&skey=${keyword}&status=${status}&gst_status=${gstStatus}&pan_status=${panStatus}`
    );
  }

  getReceipt(status, fromDate, toDate, page, pagesize, search_key = '') {
    return axios.get(
      `/admin/report/receipt/${status}/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&search=${search_key}`
    );
  }

  fetchUsersByType(userType) {
    return axios.get(`/admin/users/${userType}`);
  }

  getDeactiveUsers(usertype, fromDate, toDate, page, pagesize, keyword) {
    return axios.get(
      `/admin/deactive_users/${usertype}/${fromDate}/${toDate}?fromDate=${fromDate}&toDate=${toDate}&page=${page}&pagesize=${pagesize}&skey=${keyword}`
    );
  }

  getPlatformChargeUsers(fromDate, toDate, page, pagesize) {
    return axios.get(
      `/admin/platform_charge_users/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}`
    );
  }

  filterUsersByAdmin(data, page) {
    return axios.post(`/admin/users/filterallusers?page=${page}`, data);
  }

  getAllUsers(domainid, categoryid, projectid, user_level, hourly_rate) {
    return axios.get(
      `/getAllUsers/${domainid}/${categoryid}/${projectid}/${user_level}/${hourly_rate}`
    );
  }

  // Project Upgrades

  createUpgrade(data) {
    return axios.post('/admin/project/upgrade/create', data);
  }

  UpgradeEdit(id) {
    console.log('checking id', id);
    return axios.get(`/admin/project/upgrade/edit/${id}`);
  }

  updateUpgrade(id, data) {
    return axios.post(`/admin/project/upgrade/update/${id}`, data);
  }

  getUpgrades(page, pagesize) {
    return axios.get(`/admin/project/upgrade/report?page=${page}&pagesize=${pagesize}`);
  }

  UpgradeStatusToggle(id) {
    return axios.post(`/admin/project/upgrade/status/${id}`);
  }

  deleteUpgrade(id) {
    return axios.delete(`/admin/project/upgrade/delete/${id}`);
  }
  getUpgradeProjects() {
    return axios.get('/admin/project/upgrade/allprojectsupgrades');
  }
  // FindTalents(data){
  //     return axios.post(`/findtalents`,data);
  // }

  FindTalents(page, data) {
    return axios.post(`/findtalents?page=${page}`, data);
  }

  SearchTalents(data) {
    return axios.post(`/searchTalentUsers`, data);
  }

  GetTalents(domainid, categoryid, talent_type) {
    return axios.get(`/getTalents/${domainid}/${categoryid}/${talent_type}`);
  }

  ViewUserTalent(userid) {
    return axios.get(`/viewUsersTalent/${userid}`);
  }

  ViewUserDatabyId(userid, pagesize, page, foliosize) {
    return axios.get(
      `/ViewUserDatabyId/${userid}?page=${page}&pagesize=${pagesize}&foliosize=${foliosize}`
    );
  }
  ViewUserreviewbyId(userid, pagesize, page) {
    return axios.get(`/ViewUserReviewbyId/${userid}?page=${page}&pagesize=${pagesize}`);
  }
  ViewUserportfoliobyId(userid, pagesize, page) {
    return axios.get(`/ViewUserportfoliobyId/${userid}?page=${page}&pagesize=${pagesize}`);
  }

  CategoryWiseRecord(page, pagesize, search, frm, to) {
    return axios.get(
      `admin/category/report?page=${page}&pagesize=${pagesize}&search=${search}&frm=${frm}&to=${to}`
    );
  }

  ProfileUpdate(id, data) {
    return axios.post(`/seller/users/updateProfile/${id}`, data);
  }
  GetTrainings(domainid, categoryid) {
    return axios.get(`/getAllTrainings/${domainid}/${categoryid}`);
  }
  getCountries() {
    return axios.get('/admin/users/countries');
  }

  getCountries_basic() {
    return axios.get('/countries');
  }

  getCountry() {
    return axios.get('/getcountries');
  }

  getSellerCountries() {
    return axios.get('/seller/users/countries');
  }
  getUserById(id) {
    return axios.get(`/seller/users/edit/${id}`);
  }
  getPasswordById(id) {
    return axios.get(`/admin/users/getPassword/${id}`);
  }

  updateUser(id, data) {
    return axios.post(`/seller/users/update/${id}`, data);
  }
  updateuserpopup(data) {
    return axios.post(`/seller/users/updateuserpopup`, data);
  }

  getUserBypopup() {
    return axios.get(`/seller/users/getUserBypopup`);
  }

  AdminProfileUpdate(data) {
    return axios.post(`/admin/updateProfile`, data);
  }

  getUserCategory(id = 0) {
    return axios.get(`/seller/users/getUserCategory/${id}`);
  }

  getUserDomainCategorySkill(user_id) {
    return axios.get(`/seller/users/getUserDomainCategorySkill/${user_id}`);
  }

  AddUserCategory(data) {
    return axios.post(`/seller/users/addUserCategory`, data);
  }
  deleteUserCategory(id) {
    return axios.delete(`/seller/users/deleteUserCategory/${id}`);
  }

  AddUserSkill(data) {
    return axios.post(`/seller/users/addUserSkill`, data);
  }
  // updateUserSkill(user_skill_id,data)
  // {
  //     return axios.post(`/seller/users/updatedUserSkill/${user_skill_id}`,data);
  // }
  updateUserSkill(data) {
    return axios.post(`/seller/users/updatedUserSkill`, data);
  }
  deleteUserSkill(user_skill_id) {
    return axios.delete(`/seller/users/deleteUserSkill/${user_skill_id}`);
  }

  //For User's Language
  getActiveLanguages() {
    return axios.get(`/admin/helper_master/getLanguages`);
  }

  updateUserLanguage(user_language_id, data) {
    return axios.post(`/seller/users/updatedUserLanguage/${user_language_id}`, data);
  }
  AddLanguage(data) {
    return axios.post(`/seller/users/addLanguage`, data);
  }

  deleteUserLanguage(userLanguageId) {
    return axios.delete(`/seller/users/deleteUserLanguage/${userLanguageId}`);
  }

  // //For User's Certificate
  AddCertificate(data) {
    return axios.post('seller/users/addCertificate', data);
  }
  UpdateUserCertificate(id, data) {
    return axios.post(`/seller/users/updateUserCertificate/${id}`, data);
  }

  deleteUserCertificate(userCertificateId) {
    return axios.delete(`/seller/users/deleteUserCertificate/${userCertificateId}`);
  }

  deleteUserEducation(userEducationId) {
    return axios.delete(`/seller/users/deleteUserEducation/${userEducationId}`);
  }

  GetEmployment() {
    return axios.get('/seller/users/getEmployment');
  }

  AddExperience(data) {
    return axios.post('/seller/users/addExperience', data);
  }

  updateEmployment(data) {
    return axios.post('/seller/users/updateEmployment', data);
  }

  deleteEmployment(id) {
    return axios.delete(`/seller/users/deleteUserEmployment/${id}`);
  }

  AddOtherExperience(data) {
    return axios.post('/seller/users/addOtherExperience', data);
  }

  updateOtherExperience(data) {
    return axios.post('/seller/users/updateOtherExperience', data);
  }

  BlockUser(id) {
    return axios.post(`/admin/users/blockUser/${id}`);
  }
  UserFeatureUnfeature(id) {
    return axios.post(`/admin/users/userFeatureUnfeature/${id}`);
  }

  ChangeUserLevel(data) {
    return axios.post(`/admin/users/updateUserLevel`, data);
  }

  deleteUsers(id) {
    return axios.delete(`/admin/users/delete/${id}`);
  }

  delete_PlatformCharge_Users(id) {
    return axios.delete(`/admin/platform_charge_users/delete/${id}`);
  }

  // For User's Education
  AddEducation(data) {
    return axios.post(`/seller/users/addEducation`, data);
  }
  UpdateUserEducation(id, data) {
    return axios.post(`/seller/users/updateUserEducation/${id}`, data);
  }

  SaveBankDetails(data) {
    return axios.post(`/seller/users/addBankDetails`, data);
  }
  getBankDetails(data) {
    return axios.post(`/seller/users/getBankDetails`, data);
  }

  //8. Admin Route Functions slider
  pinCodeDetails(pincode) {
    return axios.get(`/pincodedetails/${pincode}`);
  }
  getCountriesForRegistration() {
    return axios.get('/countries');
  }
  getSlider(page) {
    return axios.get(`/admin/slider?page=${page}`);
  }
  getAllSlider() {
    return axios.get(`/admin/slider/getActiveSlider`);
  }
  getSliderByID(id) {
    return axios.get(`/admin/slider/edit/${id}`);
  }
  createSlider(data) {
    return axios.post('/admin/slider/add', data);
  }
  updateSlider(id, data) {
    return axios.post(`/admin/slider/update/${id}`, data);
  }
  deleteSlider(id) {
    return axios.delete(`/admin/slider/delete/${id}`);
  }

  getSlider(page) {
    return axios.get(`/admin/slider?page=${page}`);
  }
  getAllSlider() {
    return axios.get(`/admin/slider/getActiveSlider`);
  }
  getSliderByID(id) {
    return axios.get(`/admin/slider/edit/${id}`);
  }
  createSlider(data) {
    return axios.post('/admin/slider/add', data);
  }
  updateSlider(id, data) {
    return axios.post(`/admin/slider/update/${id}`, data);
  }
  deleteSlider(id) {
    return axios.delete(`/admin/slider/delete/${id}`);
  }

  //9. Admin Route Functions homecards
  getCard(page, pagesize) {
    return axios.get(`/admin/card?page=${page}&pagesize=${pagesize}`);
  }
  getAllCard() {
    return axios.get(`/admin/card/getActiveProposal`);
  }
  getCardByID(id) {
    return axios.get(`/admin/card/edit/${id}`);
  }
  createCard(data) {
    return axios.post('/admin/card/add', data);
  }
  updateCard(id, data) {
    return axios.post(`/admin/card/update/${id}`, data);
  }
  deleteCard(id) {
    return axios.delete(`/admin/card/delete/${id}`);
  }
  /// ratemaster  start///
  getRatemaster(page) {
    return axios.get(`/admin/ratemaster?page=${page}`);
  }
  createRatemasterinfo(data) {
    return axios.post('/admin/ratemaster/add', data);
  }
  deleteRatemasterinfo(id) {
    return axios.delete(`/admin/ratemaster/delete/${id}`);
  }
  getRatemasterinfoByID(id) {
    return axios.get(`/admin/ratemaster/edit/${id}`);
  }
  updateRatemasterinfo(id, data) {
    return axios.post(`/admin/ratemaster/update/${id}`, data);
  }

  //10. bottominfo
  getBottominfo(page, pagesize) {
    return axios.get(`/admin/bottominfo?page=${page}&pagesize=${pagesize}`);
  }

  getBottominfoByID(id) {
    return axios.get(`/admin/bottominfo/edit/${id}`);
  }
  createBottominfo(data) {
    return axios.post('/admin/bottominfo/add', data);
  }

  updateBottominfo(id, data) {
    return axios.post(`/admin/bottominfo/update/${id}`, data);
  }
  deleteBottominfo(id) {
    return axios.delete(`/admin/bottominfo/delete/${id}`);
  }

  //11. notification
  getNotification(page, pagesize) {
    return axios.get(`/admin/notification?page=${page}&pagesize=${pagesize}`);
  }

  getNotificationByID(id) {
    return axios.get(`/admin/notification/edit/${id}`);
  }
  createNotification(data) {
    return axios.post('/admin/notification/add', data);
  }
  updateNotification(id, data) {
    return axios.post(`/admin/notification/update/${id}`, data);
  }
  deleteNotification(id) {
    return axios.delete(`/admin/notification/delete/${id}`);
  }
  //12.functions for Admin side Proposals

  GetAllUsersProposals() {
    return axios.get('/admin/getAllUsersProposals');
  }
  GetProposalLists(
    fromDate,
    toDate,
    status,
    page,
    pagesize,
    key,
    selectedCategory,
    selectedSubCategory
  ) {
    return axios.get(
      `/admin/getProposalLists/${status}/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&keyword=${key}&selectedCategory=${selectedCategory}&selectedSubCategory=${selectedSubCategory}`
    );
  }
  GetProjectLists(page) {
    return axios.get(`/admin/getProjectLists?page=${page}`);
  }

  //     getPrjectList(data,fromDate,toDate,status,page,pagesize){
  //         return axios.get(`/admin/project/getprojectall/${fromDate}/${toDate}/${status}?page=${page}&pagesize=${pagesize}`,data);
  //    }
  getPrjectList(page, filter, pagesize, key, fromDate, toDate) {
    return axios.get(
      `/admin/project/getprojectall/${fromDate}/${toDate}/?page=${page}&selectedProjectType=${filter.selectedProjectType}&statustypeselected=${filter.statustypeselected}&selectedratetype=${filter.selectedratetype}&categoryType=${filter.categoryType}&pagesize=${pagesize}&keyword=${key}`
    );
  }

  projectDeactiveByDate() {
    return axios.get(`/admin/project/deactive/bydate`);
  }

  FilterProposal(data, page) {
    return axios.post(`/admin/proposalFilter?page=${page}`, data);
  }
  FilterProjectdata(data, page) {
    return axios.post(`/admin/FilterProjectdata?page=${page}`, data);
  }
  ProjectSubmitForModification(data) {
    return axios.post(`/admin/projectForModification`, data);
  }
  ProposalSubmitForModification(data) {
    return axios.post(`/admin/proposalForModification`, data);
  }
  ProposalApprovalStatus(id) {
    return axios.post(`/admin/proposalApprove/${id}`);
  }
  ProjectApprovalStatus(id) {
    return axios.post(`/admin/projectApprove/${id}`);
  }

  ProjectDeclineStatus(id) {
    return axios.post(`/admin/projectDecline/${id}`);
  }
  ProjectFeatureUnfeature(id) {
    // return axios.post(`/admin/projectFeatureUnfeature`,data);
    return axios.post(`/admin/projectFeatureUnfeature/${id}`);
  }

  ProjectPauseStatus(id) {
    return axios.post(`/admin/projectPause/${id}`);
  }

  biddingsubmit(data) {
    return axios.post(`/seller/project/Submitbidding`, data);
  }

  bidUpdateByFreelancer(data) {
    return axios.post(`/seller/project/update/bid`, data);
  }

  ProposalDeclineStatus(id) {
    return axios.post(`/admin/proposalDecline/${id}`);
  }
  ProposalPauseStatus(id) {
    return axios.post(`/admin/proposalPause/${id}`);
  }

  //13. functions for Admin side Coupons
  GetCoupons(fromDate, toDate, page, pagesize) {
    return axios.get(`/admin/coupons/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}`);
  }
  GetCouponById(id) {
    return axios.post(`/admin/coupons/edit/${id}`);
  }
  AddCoupons(data) {
    return axios.post(`/admin/coupons/add`, data);
  }
  UpdateCoupons(couponId, data) {
    return axios.post(`/admin/coupons/update/${couponId}`, data);
  }
  DeleteCoupon(id) {
    return axios.post(`/admin/coupons/delete/${id}`);
  }

  //14. functions for Admin support Ticket Master
  GetTicketTypes(page, pagesize) {
    return axios.get(`/admin/ticketTypes?page=${page}&pagesize=${pagesize}`);
  }
  AddTickets(data) {
    return axios.post(`/admin/ticketTypes/add`, data);
  }

  GetTicketTypeById(id) {
    return axios.post(`/admin/ticketTypes/edit/${id}`);
  }

  GetPlatformChargeById(id) {
    return axios.post(`/admin/platform_charge_users/edit/${id}`);
  }

  DeleteTicketType(id) {
    return axios.delete(`/admin/ticketTypes/delete/${id}`);
  }
  UpdateTickets(id, data) {
    return axios.post(`/admin/ticketTypes/update/${id}`, data);
  }

  UpdatePlatformCharge(id, data) {
    return axios.post(`/admin/platform_charge_users/update/${id}`, data);
  }

  //15. functions for Admin support Ticket Subject
  GetAllTicketTypes() {
    return axios.get('/getAllTicketTypes');
  }
  getAllSupportTicketTypes() {
    return axios.get('/getAllSupportTicketTypes');
  }
  GetSubjects(page, pagesize) {
    return axios.get(`/admin/subjects?page=${page}&pagesize=${pagesize}`);
  }

  AddSubject(data) {
    return axios.post(`/admin/subjects/add`, data);
  }
  GetSubjectById(id) {
    return axios.post(`/admin/subjects/edit/${id}`);
  }
  DeleteSubject(id) {
    return axios.delete(`/admin/subjects/delete/${id}`);
  }
  UpdateSubject(id, data) {
    return axios.post(`/admin/subjects/update/${id}`, data);
  }

  //16. functions for Admin support Ticket Subject
  GetSupportSettings(page, pagesize) {
    return axios.get(`/admin/supportSettings?page=${page}&pagesize=${pagesize}`);
  }
  GetSupportSettingById(id) {
    return axios.post(`/admin/supportSettings/edit/${id}`);
  }
  AddSupportSetting(data) {
    return axios.post(`/admin/supportSettings/add`, data);
  }
  UpdateSupportSetting(id, data) {
    return axios.post(`/admin/supportSettings/update/${id}`, data);
  }
  DeleteSupportSetting(id) {
    return axios.delete(`/admin/supportSettings/delete/${id}`);
  }

  //17. functions for Admin support Ticket Status
  GetTicketStatus(page) {
    return axios.get(`/admin/ticketStatus?page=${page}`);
  }
  GetStatus() {
    return axios.get('/getStatus');
  }
  GetTicketStatusById(id) {
    return axios.post(`/admin/ticketStatus/edit/${id}`);
  }
  AddTicketStatus(data) {
    return axios.post(`/admin/ticketStatus/add`, data);
  }
  UpdateTicketStatus(id, data) {
    return axios.post(`/admin/ticketStatus/update/${id}`, data);
  }
  DeleteTicketStatus(id) {
    return axios.delete(`/admin/ticketStatus/delete/${id}`);
  }

  //18. functions for Admin to view All Tickets
  GetTickets(fromDate, toDate, selectedStatus, selectedType, page, pagesize) {
    return axios.get(
      `/admin/tickets/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&status=${selectedStatus}&type=${selectedType}`
    );
  }
  FilterTicketsByAdmin(data) {
    return axios.post(`/admin/tickets/filterTicketByAdmin`, data);
  }

  // Term and condition
  GetTermAndCondition(page) {
    return axios.get(`/admin/terms_and_condition/report?page=${page}`);
  }

  DeleteTermAndCondition(id) {
    return axios.get(`/admin/terms_and_condition/delete?delete=${id}`);
  }

  CreateTermCondition(data) {
    return axios.post(`/admin/terms_and_condition/store`, data);
  }

  EditTermAndConditionById(id) {
    return axios.get(`/admin/terms_and_condition/edit?id=${id}`);
  }
  UpdateTermAndConditions(id, data) {
    return axios.post(`/admin/terms_and_condition/update?id=${id}`, data);
  }

  //17. functions for Admin Payment Settings
  GetSellerLevel(page) {
    return axios.get(`/admin/seller_levels?page=${page}`);
  }
  GetSellerLevelById(id) {
    return axios.post(`/admin/seller_levels/edit/${id}`);
  }
  AddSellerLevel(data) {
    return axios.post('/admin/seller_levels/add', data);
  }
  UpdateSellerLevel(id, data) {
    return axios.post(`/admin/seller_levels/update/${id}`, data);
  }
  DeleteSellerLevel(id) {
    return axios.delete(`/admin/seller_levels/delete/${id}`);
  }

  //18. functions for Admin Payment Settings
  GetPaymentSetting() {
    return axios.get('/admin/paymentSettings');
  }
  AddPaymentSetting(data) {
    return axios.post('/admin/paymentSettings/add', data);
  }
  UpdatePaymentSetting(id, data) {
    return axios.post(`/admin/paymentSettings/update/${id}`, data);
  }

  //19. functions for Admin Seller Payment Settings
  GetSellerLevels() {
    return axios.get('/admin/getSellerLevels');
  }
  GetSellerPaymentSetting(page) {
    return axios.get(`/admin/seller_payment_Settings?page=${page}`);
  }
  GetSellerPaymentSettingById(id) {
    return axios.post(`/admin/seller_payment_Settings/edit/${id}`);
  }
  AddSellerPaymentSetting(data) {
    return axios.post('/admin/seller_payment_Settings/add', data);
  }
  UpdateSellerPaymentSetting(id, data) {
    return axios.post(`/admin/seller_payment_Settings/update/${id}`, data);
  }
  DeleteSellerPaymentSetting(id) {
    return axios.delete(`/admin/seller_payment_Settings/delete/${id}`);
  }

  //Admin Email Setup
  emailSetup(type, data) {
    return axios.post(`/admin/global_setup/email_setup/${type}`, data);
  }

  //Admin Email Template
  getEmailTemplates(page, pagesize, search = '') {
    return axios.get(
      `/admin/global_setup/email_template/get?page=${page}&pagesize=${pagesize}&keyword=${search}`
    );
  }
  addEmailTemplates(data) {
    return axios.post(`/admin/global_setup/email_template/add`, data);
  }
  updateEmailTemplates(data) {
    return axios.post(`/admin/global_setup/email_template/update`, data);
  }
  deleteEmailTemplates(id) {
    return axios.get(`/admin/global_setup/email_template/delete/${id}`);
  }

  updateImage(data) {
    return axios.post(`/admin/global_setup/email_template/update_image`, data);
  }
  //Email Automation
  getEmailAutomation() {
    return axios.get(`/admin/global_setup/email_automation/get`);
  }
  addEmailAutomation(data) {
    return axios.post(`/admin/global_setup/email_automation/add`, data);
  }
  updateEmailAutomation(data) {
    return axios.post(`/admin/global_setup/email_automation/update`, data);
  }
  getEmailAutomationForm($id) {
    return axios.get(`/admin/global_setup/email_automation/formdata?event_id=${$id}`);
  }
  deleteEmailAutomation(id) {
    return axios.get(`/admin/global_setup/email_automation/delete/${id}`);
  }
  getimages(page, pagesize, search) {
    return axios.get(`/admin/images/get?page=${page}&pagesize=${pagesize}&search=${search}`);
  }
  getimagesdrop() {
    return axios.get(`/admin/images/getallimages`);
  }
  deleteimage(id) {
    return axios.get(`/admin/images/delete/${id}`);
  }
  storeimage(data) {
    return axios.post(`/admin/images/store`, data);
  }

  //prodcut event

  getProductEventName(page, data) {
    return axios.post(`/admin/global_setup/event/product_event/get?page=${page}`, data);
  }
  addProductEventName(data) {
    return axios.post(`/admin/global_setup/event/product_event/add`, data);
  }
  updateProductEventName(data) {
    return axios.post(`/admin/global_setup/event/product_event/update`, data);
  }

  deleteProductEventName(id) {
    return axios.get(`/admin/global_setup/event/product_event/delete/${id}`);
  }

  //Landing Page Master
  getLandingPageMaster(page, pagesize, search) {
    return axios.get(
      `/admin/master/lading_page/get?page=${page}&pagesize=${pagesize}&search=${search}`
    );
  }
  addLandingPageMaster(data) {
    return axios.post(`/admin/master/lading_page/add`, data);
  }
  updateLandingPageMaster(data) {
    return axios.post(`/admin/master/lading_page/update`, data);
  }

  deleteLandingPageMaster(id) {
    return axios.delete(`/admin/master/lading_page/delete/${id}`);
  }

  //front  pages master

  getFrontPages(page, pagesize, search) {
    return axios.get(
      `/admin/master/front_page/get?page=${page}&pagesize=${pagesize}&search=${search}`
    );
  }

  addFrontPages(data) {
    return axios.post(`admin/master/front_page/add`, data);
  }
  updatePageFront(data) {
    return axios.post(`/admin/master/front_page/update`, data);
  }

  deletePageFront(id) {
    return axios.delete(`/admin/master/front_page/delete/${id}`);
  }
  //seo
  getPageSeo(page_id, page, pagesize, search) {
    return axios.get(
      `/admin/master/front_page/seo/get?page_id=${page_id}&page=${page}&pagesize=${pagesize}&search=${search}`
    );
  }
  addPageSeo(data) {
    return axios.post(`/admin/master/front_page/seo/add`, data);
  }
  updatePageSeo(data) {
    return axios.post(`/admin/master/front_page/seo/update`, data);
  }
  deletePageSeo(id) {
    return axios.delete(`/admin/master/front_page/seo/delete/${id}`);
  }

  getMicroJobSeo() {
    return axios.get(`/admin/master/microjob_seo/get`);
  }
  saveMicroJobSeo(data) {
    return axios.post(`/admin/master/microjob_seo/save`, data);
  }

  //Url Redirect
  addUrlRedirect(data) {
    return axios.post(`admin/master/url_redirect/add`, data);
  }

  getUrlRedirect(page, pagesize, search) {
    return axios.get(
      `/admin/master/url_redirect/get?page=${page}&pagesize=${pagesize}&search=${search}`
    );
  }

  updateUrlRedirect(data) {
    return axios.post(`/admin/master/url_redirect/update`, data);
  }

  updateUrlStatus(data) {
    return axios.post(`/admin/master/url_redirect/updateStatus`, data);
  }

  deleteUrlRedirect(id) {
    return axios.delete(`/admin/master/url_redirect/delete/${id}`);
  }

  //Landing Page Metas
  getPageMetaMaster(page_id, page, pagesize, search) {
    return axios.get(
      `/admin/master/lading_page/meta/get?page_id=${page_id}&page=${page}&pagesize=${pagesize}&search=${search}`
    );
  }
  addPageMetaMaster(data) {
    return axios.post(`/admin/master/lading_page/meta/add`, data);
  }
  updatePageMetaMaster(data) {
    return axios.post(`/admin/master/lading_page/meta/update`, data);
  }

  deletePageMetaMaster(id) {
    return axios.delete(`/admin/master/lading_page/meta/delete/${id}`);
  }

  //20. functions for Admin Resource Master

  GetResourceMaster(page, pagesize) {
    return axios.get(`/admin/resource_master?page=${page}&pagesize=${pagesize}`);
  }
  GetResourceMasterById(id) {
    return axios.get(`/admin/resource_master/edit/${id}`);
  }
  AddResourceMaster(data) {
    return axios.post('/admin/resource_master/add', data);
  }
  UpdateResourceMaster(id, data) {
    return axios.post(`/admin/resource_master/update/${id}`, data);
  }
  DeleteResourceMaster(id) {
    return axios.delete(`/admin/resource_master/delete/${id}`);
  }

  //21. functions for Admin Add Resources

  GetResourcesList(page, pagesize) {
    return axios.get(`/admin/resources?page=${page}&pagesize=${pagesize}`);
  }
  GetPostById(id) {
    return axios.get(`/admin/resources/edit/${id}`);
  }
  checkSlug(slug) {
    return axios.get(`/admin/resources/checkslug/${slug}`);
  }
  AddResources(data) {
    return axios.post('/admin/resources/add', data);
  }

  UpdateResources(data) {
    return axios.post('/admin/resources/update', data);
  }

  ResourceActiveStatusToggle(id) {
    return axios.post(`/admin/resources/deactivate/${id}`);
  }

  ResourceFeatureUnfeature(id) {
    return axios.post(`/admin/resources/resourceFeatureUnfeature/${id}`);
  }

  deleteResource(id) {
    return axios.delete(`/admin/resources/delete/${id}`);
  }

  ResourceApprovalStatus(id) {
    return axios.post(`/admin/resources/approveStatus/${id}`);
  }

  LoadResourceData() {
    return axios.get('/admin/loadResource');
  }

  SearchResources(data) {
    return axios.post('/admin/resources/searchResource', data);
  }

  //MAke Proposal Featured
  MakeProposalFeatured(data) {
    return axios.post(`/admin/make_featured`, data);
  }
  UnfeaturedProposal(id) {
    return axios.post(`/seller/unfeatured/${id}`);
  }
  ProposalActiveDeactive(data) {
    return axios.post(`/seller/proposals/changeActiveDeactive`, data);
  }
  Makepayment(data) {
    return axios.post(`updatepayment`, data);
  }

  //19. For change Ticket status
  changeTicketStatus(id, data) {
    return axios.post(`/admin/changeTicketStatus/${id}`, data);
  }
  getprojectamount(id) {
    return axios.post(`/admin/getprojectamount/${id}`);
  }
  RaiseRequest(data) {
    return axios.post(`/admin/raiserequest`, data);
  }
  //20. For Order Details
  GetOrders(fromDate, toDate, value, status, page, pagesize) {
    return axios.get(
      `/admin/orders/${value}/${fromDate}/${toDate}/${value}/${status}?page=${page}&pagesize=${pagesize}`
    );
  }
  OrderCancel(data) {
    return axios.post('/seller/orders/cancel', data);
  }

  //21. For Accounting & Sales
  GetAllSales(fromDate, toDate, value, page, pagesize) {
    return axios.get(
      `/admin/sales/${value}/${fromDate}/${toDate}/${value}?page=${page}&pagesize=${pagesize}`
    );
  }
  GetAllSalesAccount(fromDate, toDate, page, pagesize) {
    return axios.get(
      `/admin/sales/freelancer_account/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}`
    );
  }
  //22. For Cancellation Master
  GetCancellationMaster(page, pagesize) {
    return axios.get(`/admin/cancellation_master?page=${page}&pagesize=${pagesize}`);
  }
  AddCancellationMaster(data) {
    return axios.post('/admin/cancellation_master/add', data);
  }
  GetCancellationMasterById(data) {
    return axios.post('/admin/cancellation_master/edit', data);
  }
  UpdateCancellationMaster(data) {
    return axios.post('/admin/cancellation_master/update', data);
  }
  DeleteCancellationMaster(id) {
    return axios.delete(`/admin/cancellation_master/delete/${id}`);
  }
  //........Routes For Payouts.................
  GetPayouts(fromDate, toDate, status, page, pagesize) {
    // return axios.get(`/admin/wallets/payouts/${fromDate}/${toDate}/${status}?page=${page}`);
    return axios.get(
      `/admin/wallets/payouts/${fromDate}/${toDate}/${status}?page=${page}&pagesize=${pagesize}`
    );
  }
  GetRefund(fromDate, toDate, status, page, pagesize) {
    // return axios.get(`/admin/wallets/payouts/${fromDate}/${toDate}/${status}?page=${page}`);
    return axios.get(
      `/admin/wallets/refund/${fromDate}/${toDate}/${status}?page=${page}&pagesize=${pagesize}`
    );
  }

  getsellerorder(page, pagesize, seller_id) {
    // return axios.get(`/admin/wallets/payouts/${fromDate}/${toDate}/${status}?page=${page}`);
    return axios.get(
      `/admin/wallets/sellerorder?page=${page}&pagesize=${pagesize}&seller=${seller_id}`
    );
  }
  ApproveDeclinePayout(data) {
    return axios.post(`/admin/wallets/approveDecline`, data);
  }
  ApproveDeclineRefund(data) {
    return axios.post(`/admin/wallets/refund/approveDecline`, data);
  }

  couponcode(couponcode) {
    return axios.get(`/couponcode/${couponcode}`);
  }
  getprocessingfee() {
    return axios.get(`/processingfee`);
  }

  //Admin Routes for Trainings
  GetTrainingsLists(status, page, from = 0, to = 0) {
    return axios.get(`/admin/getTrainingLists/${status}?page=${page}&form=${from}&to=${to}`);
  }

  GetTrainersList(resetDate, fromDate, toDate, page, pagesize, search = null) {
    return axios.get(
      `/admin/training/getTrainers?page=${page}&pagesize=${pagesize}&resetDate=${resetDate}&from=${fromDate}&to=${toDate}&search=${search}`
    );
  }
  GetAllTrainerHasClass() {
    return axios.get(`/admin/tutors/getallTrainers`);
  }

  UpdateClassStatusByAdmin(data) {
    return axios.post(`/admin/training/updateClassStatus`, data);
  }
  GetEnrolledStudent(id, page, pagesize, search) {
    return axios.get(
      `/admin/tutors/class/enrolled/get/${id}?page=${page}&pagesize=${pagesize}&search_key=${search}`
    );
  }

  GetClassReview(id, page, pagesize, search) {
    return axios.get(
      `/admin/tutors/class/review/get/${id}?page=${page}&pagesize=${pagesize}&search_key=${search}`
    );
  }
  ClassFeatureUnfeature(id) {
    return axios.post(`/admin/training/classFeatureUnfeature/${id}`);
  }
  TrainingClassSubmitForModification(data) {
    return axios.post(`/admin/tutors/trainingClassModification`, data);
  }

  DisplayTrainingClassModification(id) {
    return axios.post(`/admin/tutors/display_training_class_modification/${id}`);
  }

  // Routes for help contents
  getHelpTopics(page, pagesize) {
    return axios.get(`/admin/helps?page=${page}&pagesize=${pagesize}`);
  }

  addHelpTopics(data) {
    return axios.post('/admin/helps/add', data);
  }

  editHelpTopics(id) {
    return axios.get(`/admin/helps/edit/${id}`);
  }

  updateHelpTopics(data) {
    return axios.post('/admin/helps/update', data);
  }

  deleteHelpTopic(id) {
    return axios.delete(`/admin/helps/delete/${id}`);
  }

  GetHelpContent(id, page) {
    return axios.get(`/admin/helpContents/${id}?page=${page}`);
  }

  AddHelpContent(data) {
    return axios.post('/admin/helpContents/add', data);
  }

  EditHelpContent(id) {
    return axios.get(`/admin/helpContents/edit/${id}`);
  }

  UpdateHelpContent(data) {
    return axios.post('/admin/helpContents/update', data);
  }

  DeleteHelpContent(id) {
    return axios.delete(`/admin/helpContents/delete/${id}`);
  }

  // Routes for get all reviews
  getAllReviews(fromDate, toDate, user_type, review_type, page, pagesize, keyword) {
    return axios.get(
      `/admin/allreviews/${fromDate}/${toDate}/${user_type}/${review_type}?page=${page}&pagesize=${pagesize}&skey=${keyword}`
    );
  }
  ReviewFeatureUnfeature(review_for, id) {
    return axios.post(`/admin/reviewFeatureUnfeature/${review_for}/${id}`);
  }

  //22. Routes for Admin Menu Master
  GetMenus(page, pagesize) {
    return axios.get(`/admin/menu?page=${page}&pagesize=${pagesize}`);
  }
  AddMenu(data) {
    return axios.post('/admin/menu/add', data);
  }
  GetMenuById(data) {
    return axios.post('/admin/menu/edit', data);
  }
  UpdateMenu(data) {
    return axios.post('/admin/menu/update', data);
  }
  DeleteMenu(id) {
    return axios.delete(`/admin/menu/delete/${id}`);
  }

  MenuActiveStatusToggle(id) {
    return axios.post(`/admin/menu/deactivate/${id}`);
  }

  MenuIsMainMenuToggle(id) {
    return axios.post(`/admin/menu/ismainmenu_toggle/${id}`);
  }

  //23. Routes for Admin Roles Master
  GetRoles(page, pagesize) {
    return axios.get(`/admin/role?page=${page}&pagesize=${pagesize}`);
  }
  AddRole(data) {
    return axios.post('/admin/role/add', data);
  }
  GetRoleById(data) {
    return axios.post('/admin/role/edit', data);
  }
  UpdateRole(data) {
    return axios.post('/admin/role/update', data);
  }
  DeleteRole(id) {
    return axios.delete(`/admin/role/delete/${id}`);
  }

  //23. Routes for Admin Menu Permissions

  GetMenuPermissions(page, pagesize) {
    return axios.get(`/admin/menu_permission?page=${page}&pagesize=${pagesize}`);
  }
  AddMenuPermission(data) {
    return axios.post('/admin/menu_permission/add', data);
  }
  GetMenuPermissionById(data) {
    return axios.post('/admin/menu_permission/edit', data);
  }
  UpdateMenuPermission(data) {
    return axios.post('/admin/menu_permission/update', data);
  }
  DeleteMenuPermission(id) {
    return axios.delete(`/admin/menu_permission/delete/${id}`);
  }

  GetAllRoles() {
    return axios.get(`/admin/getallroles`);
  }
  GetAllUsers() {
    return axios.get(`/admin/getallusers`);
  }

  AddUserByAdmin(data) {
    return axios.post('/admin/user_management/admin_users/add', data);
  }

  editAdminUser(id) {
    return axios.get(`/admin/user_management/admin_users/edit/${id}`);
  }
  updateAdminUser(id, data) {
    return axios.post(`/admin/user_management/admin_users/update/${id}`, data);
  }
  deleteAdminUser(id) {
    return axios.delete(`/admin/user_management/admin_users/delete/${id}`);
  }
  deactiveAdminUser(data) {
    return axios.post(`/admin/user_management/admin_users/deactive`, data);
  }

  getUserRoles(page, pagesize, type) {
    return axios.get(
      `/admin/user_management/user_role/get?page=${page}&pagesize=${pagesize}&type=${type}`
    );
  }

  // USer management Add Permission

  getUserPermissions(page, pagesize, type, search) {
    return axios.get(
      `/admin/user_management/user_permission/get?page=${page}&pagesize=${pagesize}&type=${type}&keyword=${search}`
    );
  }
  addUserPermission(data) {
    return axios.post(`/admin/user_management/user_permission/create`, data);
  }
  deleteUserPermission(id) {
    return axios.delete(`/admin/user_management/user_permission/delete/${id}`);
  }
  getAllUserRoles(page, pagesize) {
    return axios.get(`/admin/user_management/user_role/get/all`);
  }

  addUserRoles(data) {
    return axios.post(`/admin/user_management/user_role/create`, data);
  }
  updateUserRoles(data) {
    return axios.post(`/admin/user_management/user_role/update`, data);
  }
  deleteUserRoles(id) {
    return axios.delete(`/admin/user_management/user_role/delete/${id}`);
  }

  Permission(type, rolename) {
    return axios.get(`/admin/user_management/permission/get?type=${type}&role=${rolename}`);
  }

  updatePermission(type, data) {
    return axios.post(`/admin/user_management/${type}_permission/update`, data);
  }
  updatePermissionNewAPI(data) {
    return axios.post(`/admin/user_management/role_assign_permission`, data);
  }

  userWithRole(type, page, pagesize, search_key) {
    return axios.get(
      `/admin/user_management/user_with_role/get?type=${type}&page=${page}&pagesize=${pagesize}&search_key=${search_key}`
    );
  }

  updateUserRole(type, data) {
    return axios.post(`/admin/user_management/update_user_role/${type}`, data);
  }

  //--------------------------  For Dyamic Landing Page Routes Start---------------------------------------------

  //Record

  getLandingPage() {
    return axios.get(`/admin/dynamic/landing/get`);
  }

  getLandingPageOffer(data) {
    return axios.post(`/admin/dynamic/landing/offer`, data);
  }

  getLandingPagefaq(data) {
    return axios.post(`/admin/dynamic/landing/faq`, data);
  }
  getLandingPagecategory(data) {
    return axios.post(`/admin/dynamic/landing/category`, data);
  }

  //create

  publishLandingPage(
    data //store data in "data"
  ) {
    //url from admin.php
    return axios.post(`/admin/dynamic/landing/create`, data); //pass data in "data through url"
  }

  LandingPageOffer(
    data //store data in "data"
  ) {
    return axios.post(`/admin/dynamic/landing/createoffer`, data); //pass data in "data through url"
  }

  LandingPageFAQ(
    data //store data in "data"
  ) {
    return axios.post(`/admin/dynamic/landing/createfaq`, data); //pass data in "data through url"
  }

  LandingPageCategory(
    data //store data in "data"
  ) {
    return axios.post(`/admin/dynamic/landing/createcategory`, data); //pass data in "data through url"
  }

  //Enterprise

  Enterprisepage(data) {
    return axios.post(`/admin/enterprise/homepage/store`, data);
  }

  getEnterpriseHome() {
    return axios.get('/admin/enterprise/homepage/show');
  }

  //FAQ Enterprise

  Faq_createpage(data) {
    return axios.post(`/admin/enterprise/faq/store`, data);
  }

  getFaqdata() {
    return axios.get('/admin/enterprise/faq/show');
  }

  deleteFaq(id) {
    return axios.delete(`/admin/enterprise/faq/delete/${id}`);
  }

  getFaqById(id) {
    return axios.get(`/admin/enterprise/faq/edit/${id}`);
  }

  updateFaq(id, payload) {
    return axios.put(`/admin/enterprise/faq/update/${id}`, payload);
  }

  //testimonial Enterprise

  Testimonial_createpage(data) {
    return axios.post(`/admin/enterprise/testimonial/store`, data);
  }

  getTestimonialdata() {
    return axios.get('/admin/enterprise/testimonial/show');
  }

  getTestimonialById(id) {
    return axios.get(`/admin/enterprise/testimonial/edit/${id}`);
  }

  updateTestimonial(id, formData) {
    formData.append('_method', 'PUT');
    return axios.post(`/admin/enterprise/testimonial/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  deleteTestimonial(id) {
    return axios.delete(`/admin/enterprise/testimonial/delete/${id}`);
  }

  //Layput Enterprise

  getLayoutSections() {
    return axios.get('/admin/enterprise/layout/list');
  }

  updateLayoutOrder(order) {
    return axios.post('/admin/enterprise/layout/update_order', { order });
  }

  toggleLayoutActiveStatus(payload) {
    return axios.post('/admin/enterprise/layout/toggle_active', payload);
  }

  industryCreate(data) {
    return axios.post(`/admin/enterprise/industry/store`, data);
  }

  getIndustryById(id) {
    return axios.get(`/admin/enterprise/industry/edit/${id}`);
  }

  updateIndustry(id, formData) {
    formData.append('_method', 'PUT');
    return axios.post(`/admin/enterprise/industry/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  getIndustrydata() {
    return axios.get('/admin/enterprise/industry/show');
  }

  deleteIndustry(id) {
    return axios.delete(`/admin/enterprise/industry/delete/${id}`);
  }

  //footer Enterprise

  footerContentCreate(data) {
    return axios.post(`/admin/enterprise/footerContent/store`, data);
  }

  getFooterContentById(id) {
    return axios.get(`/admin/enterprise/footerContent/edit/${id}`);
  }

  getFooterContentData() {
    return axios.get('/admin/enterprise/footerContent/show');
  }

  updateFooterContent(id, formData) {
    formData.append('_method', 'PUT');
    return axios.post(`/admin/enterprise/footerContent/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  deleteFooterContent(id) {
    return axios.delete(`/admin/enterprise/footerContent/delete/${id}`);
  }
  //Category Enterprise

  Category_createpage(data) {
    return axios.post(`/admin/enterprise/category/store`, data);
  }

  getCategorydata() {
    return axios.get('/admin/enterprise/category/show');
  }

  getEnterpriseCategoryById(id) {
    return axios.get(`/admin/enterprise/category/edit/${id}`);
  }

  updateEnterpriseCategory(id, formData) {
    formData.append('_method', 'PUT');
    return axios.post(`/admin/enterprise/category/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  deleteCategory(id) {
    return axios.delete(`/admin/enterprise/category/delete/${id}`);
  }
  //Ticker Enterprise

  Ticker_createpage(data) {
    return axios.post(`/admin/enterprise/ticker/store`, data);
  }

  getTickerdata(params = {}) {
    return axios.get('/admin/enterprise/ticker/show', { params });
  }

  toggleTickerStatus(id) {
    return axios.patch(`/admin/enterprise/ticker/${id}/toggle-status`);
  }

  getTickerById(id) {
    return axios.get(`/admin/enterprise/ticker/edit/${id}`);
  }

  updateTicker(id, formData) {
    formData.append('_method', 'PUT');
    return axios.post(`/admin/enterprise/ticker/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  deleteTicker(id) {
    return axios.delete(`/admin/enterprise/ticker/delete/${id}`);
  }

  //blog-casestudy enterprise

  BlogCasestudyCreate(data) {
    return axios.post(`/admin/enterprise/blog-casestudy/store`, data);
  }
  getBlogCaseStudyById(id) {
    return axios.get(`/admin/enterprise/blog-casestudy/edit/${id}`);
  }

  updateBlogCasestudy(id, formData) {
    formData.append('_method', 'PUT');
    return axios.post(`/admin/enterprise/blog-casestudy/update/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  getBlogCasestudyData() {
    return axios.get('/admin/enterprise/blog-casestudy/show');
  }

  deleteBlogCasestudy(id) {
    return axios.delete(`/admin/enterprise/blog-casestudy/delete/${id}`);
  }

  //Audit Form
  getAuditData() {
    return axios.get('/admin/enterprise/audit/report');
  }
  //Enquiry Form
  getEnquiryData() {
    return axios.get('/admin/enterprise/enquiry/report');
  }

  //Enterprise Ends

  //Edit
  EditLandingPage(data) {
    return axios.post(`/admin/dynamic/landing/editpage`, data);
  }

  EditLandingPageOffer(data) {
    return axios.post(`/admin/dynamic/landing/editoffer`, data);
  }

  EditLandingPageFaq(data) {
    return axios.post(`/admin/dynamic/landing/editfaq`, data);
  }

  //Update
  // UpdateLandingPage(data){
  //     return axios.post(`/admin/dynamic/landing/updatepage`,data);
  // }

  //Delete

  DestroyLandingPage(data) {
    return axios.post(`/admin/dynamic/landing/destroypage`, data);
  }

  DestroyLandingPageOffer(data) {
    return axios.post(`/admin/dynamic/landing/destroyoffer`, data);
  }

  DestroyLandingPageFAQ(data) {
    return axios.post(`/admin/dynamic/landing/destroyfaq`, data);
  }

  DestroyLandingPageCategory(data) {
    return axios.post(`/admin/dynamic/landing/destroycategory`, data);
  }

  //-------------------------- For Dyamic Landing Page Routes End---------------------------------------------

  //-------------------------- 2 .For Seller Dashboard Routes---------------------------------------------

  //1-------- for Seller Proposals-------------
  SellerProposalLists(fromDate, toDate, userID, status, page, pagesize) {
    return axios.post(
      `/seller/proposals/getSellerProposalList/${fromDate}/${toDate}/${userID}/${status}?page=${page}&pagesize=${pagesize}`
    );
  }

  getPaymentSetting() {
    return axios.get('/seller/getPaymentSetting');
  }
  PayForFeatured(data) {
    return axios.post('/seller/payformakeFeatured', data);
  }
  PaymentDone(data) {
    return axios.post('/seller/paymentFeatureComplete', data);
  }
  GetDraftProposals() {
    return axios.get('/seller/proposals/drafts');
  }
  SellerModificationProposalLists(page) {
    return axios.get(`/seller/proposals/getSellerModificationProposalList?page=${page}`);
  }

  SellerModificationProjectLists(id, page) {
    return axios.get(`/seller/project/getSellerModificationProjectList/${id}?page=${page}`);
  }

  getAllCategoryById(DomainId) {
    return axios.get(`/seller/proposals/getCategoryByDomainId/${DomainId}`);
  }

  getSearchTags() {
    return axios.get(`/seller/proposals/getSearchTags`);
  }

  AddOverView(data) {
    return axios.post(`/seller/proposals/addOverview`, data);
  }
  UpdateOverView(ProposalID, data) {
    return axios.post(`/seller/proposals/updateOverview/${ProposalID}`, data);
  }

  AddPackages(data) {
    return axios.post(`/seller/proposals/addPackages`, data);
  }
  UpdatePackages(data) {
    return axios.post('/seller/proposals/updatePackages', data);
  }
  //Here function for Proposal Extra Service
  GetExtraServices(ProposalID) {
    return axios.post(`/seller/proposals/getExtraService/${ProposalID}`);
  }
  AddExtraService(data) {
    return axios.post('/seller/proposals/addExtraServices', data);
  }
  UpdateExtraService(id, data) {
    return axios.post(`/seller/proposals/updateExtraServices/${id}`, data);
  }
  DeleteExtraService(id) {
    return axios.delete(`/seller/proposals/deleteExtraServices/${id}`);
  }
  AddProposalGallery(data) {
    return axios.post(`/seller/proposals/addGallery`, data);
  }
  GetSellerProposalDetails(ProposalID) {
    return axios.post(`/seller/proposals/getSellerProposal/${ProposalID}`);
  }

  GetProposalDescription(ProposalID) {
    return axios.post(`/seller/proposals/getProposalDescription/${ProposalID}`);
  }
  GetProposalFaq(ProposalID) {
    return axios.get(`/getProposalFaq/${ProposalID}`);
  }

  GetPackageByProposalId(ProposalID) {
    return axios.post(`/seller/proposals/getPackageByProposalId/${ProposalID}`);
  }

  AddDescriptionFaq(data) {
    return axios.post(`/seller/proposals/addFaq`, data);
  }
  UpdateDescriptionFaq(data) {
    return axios.post(`/seller/proposals/updateFaq`, data);
  }
  publishProposal(data) {
    return axios.post('/seller/proposals/publish', data);
  }
  reSubmitProposal(id, user_id) {
    return axios.post(`/seller/proposals/reSubmitProposal/${id}/${user_id}`);
  }
  reSubmitProject(project_id) {
    return axios.post(`/seller/project/reSubmitProject/${project_id}`);
  }
  sendmessage(data) {
    return axios.post(`/seller/proposals/conversation`, data);
  }
  orderToProgress(data) {
    return axios.post(`/seller/proposals/orderstatus/toprogress`, data);
  }

  sendmessage1(data) {
    return axios.post(`/sendmessage1`, data);
  }

  payfixedprice(data) {
    return axios.post(`/seller/project/getfixedprice`, data);
  }

  getlistingtype() {
    return axios.get('/seller/project/getlistingtype/');
  }
  getPrject(fromDate, toDate, status, page, pagesize) {
    return axios.get(
      `/seller/project/getprojectall/${fromDate}/${toDate}/${status}?page=${page}&pagesize=${pagesize}`
    );
  }

  getPrjectfront(page) {
    return axios.get(`/seller/project/getprojectallfront?page=${page}`);
  }

  EditProjectId(project_id) {
    return axios.get(`/seller/project/edit/${project_id}`);
  }

  submitproject(data) {
    return axios.post(`/seller/project/projectsubmit`, data);
  }
  partpayment(data) {
    return axios.post(`/seller/project/partpayment`, data);
  }

  // 1st step project add ///
  postprojectuser(data) {
    return axios.post(`/seller/project/postprojectuser`, data);
  }

  getClientDetails() {
    return axios.get(`/seller/project/getclientdetails`);
  }

  updateClientAddress(id, data) {
    return axios.post(`/seller/project/updateclientaddress/${id}`, data);
  }

  /// end

  // Deliver Project by Seller
  deliverProject(data) {
    return axios.post('/seller/project/deliver', data);
  }
  requestProject(data) {
    return axios.post('/seller/project/requestRevision', data);
  }
  getReviews(data) {
    return axios.post('/seller/getreviews', data);
  }
  acceptReview(data) {
    return axios.post('/seller/review/acceptReview', data);
  }

  SearchProject(data) {
    return axios.post(`/seller/project/searchProject`, data);
  }

  //new chat api
  getAllUserChatRooms(room_id = 'all', type = '') {
    return axios.get(`/seller/chat/room/get/${room_id}/${type}`);
  }

  getMessageByRoom(orderid, ordertype) {
    return axios.get(`/seller/chat/message/get/${orderid}/${ordertype}`);
  }
  sendMessageByRoom(data) {
    return axios.post(`/seller/chat/message/send`, data);
  }
  getChatFiles(orderid, ordertype) {
    return axios.get(`/seller/chat/file/get/${orderid}/${ordertype}`);
  }
  zoomMeeting(data) {
    return axios.post(`/seller/chat/zoom/link`, data);
  }

  getUserChats(data) {
    return axios.post(`/seller/proposals/getmessage`, data);
  }
  sendUserChat(data) {
    return axios.post(`/seller/proposals/sendmessage`, data);
  }

  getmessage(order_id, ordertype, readdata) {
    return axios.get(`/seller/proposals/getmessage/${order_id}/${ordertype}/${readdata}`);
  }

  getOrderLists(fromDate, toDate, order_type, userID, orderstatus, page) {
    return axios.get(
      `/seller/proposals/getorderlist/${fromDate}/${toDate}/${order_type}/${userID}/${orderstatus}?page=${page}`
    );
  }

  SellerOrderLists(userID, page) {
    return axios.post(`/seller/proposals/getSellerOrderList/${userID}?page=${page}`);
  }

  SellerActiveOrderLists(userID, page) {
    return axios.post(`/seller/proposals/getSellerActiveOrderList/${userID}?page=${page}`);
  }
  SellerDeliveredOrderLists(userID, page) {
    return axios.post(`/seller/proposals/getSellerDeliveredOrderList/${userID}?page=${page}`);
  }
  SellerCompletedOrderLists(userID, page) {
    return axios.post(`/seller/proposals/getSellerCompletedOrderList/${userID}?page=${page}`);
  }
  SellerCancelledOrderLists(userID, page) {
    return axios.post(`/seller/proposals/getSellerCancelledOrderList/${userID}?page=${page}`);
  }
  getorderdetail(data) {
    return axios.post(`/seller/proposals/getorderdetaildata`, data);
  }

  DeleteFaq(id) {
    return axios.delete(`/seller/proposals/deleteFaq/${id}`);
  }
  saveProposalDescription(id, data) {
    return axios.post(`/seller/proposals/saveProposalFaq/${id}`, data);
  }

  DeleteUserProposal(id, UserId) {
    return axios.delete(`/seller/deleteProposal/${id}/${UserId}`);
  }

  //2.(A)------- for Seller Support Tickets-------------
  GetMyTickets(fromDate, toDate, userID, page) {
    return axios.get(`/seller/my_tickets/${fromDate}/${toDate}/${userID}?page=${page}`);
  }
  GetSubjectByTicketTypeId(id) {
    return axios.post(`/seller/my_tickets/getSubjectByTicketType/${id}`);
  }
  getOrderNumbers(userID = null) {
    return axios.get(`/seller/my_tickets/getOrderNo/${userID}`);
  }
  getmilestones(project_id) {
    return axios.get(`/seller/my_tickets/getmilestone/${project_id}`);
  }
  createTicket(data) {
    return axios.post('/seller/my_tickets/createTicket', data);
  }
  //Filter
  getFilterByTicketTypes(data) {
    return axios.post('/seller/my_tickets/getSellerTicketsFilterByTicketTypes', data);
  }
  FilterTickets(data) {
    return axios.post('/seller/my_tickets/filterTickets', data);
  }
  //2.(B)----------Ticket Chats-------------------------
  loadChats(id) {
    return axios.get(`/seller/supportchats/${id}`);
  }
  SupportChatting(data) {
    return axios.post('/seller/supportchats/chatting', data);
  }
  GetTicketDetailsById(id) {
    return axios.post(`/seller/supportchats/getTicketDetailsById/${id}`);
  }
  AddTicketReplyByAdmin(data) {
    return axios.post('/admin/support/chat/reply', data);
  }
  getTicketAllbyAdmin(ticketID) {
    return axios.get(`/admin/support/chat/get/${ticketID}`);
  }
  //----------------------------Seller Hourly Rate and Summary ----------------------
  SaveSummary(id, data) {
    return axios.post(`/seller/users/saveSummary/${id}`, data);
  }
  //----------------------------Seller Portfolio ----------------------
  getPortFolio(id = 0) {
    return axios.get(`/seller/user_portfolio/${id}`);
  }
  Addportfolio(data) {
    return axios.post('/seller/user_portfolio/add', data);
  }
  storeImg(data) {
    return axios.post('/seller/user_portfolio/addImg', data);
  }
  EditPortfolio(id) {
    return axios.get(`/seller/user_portfolio/edit/${id}`);
  }
  Updateportfolio(data) {
    return axios.post(`/seller/user_portfolio/update`, data);
  }
  Deleteportfolio(id) {
    return axios.delete(`/seller/user_portfolio/delete/${id}`);
  }
  //--------------------------Seller Filter Freelancer-------------------------
  SearchFreelancer(data) {
    return axios.post(`/seller/users/searchFreelancer`, data);
  }

  FilterFreelancer(data) {
    return axios.post('/seller/users/filterFreelancer', data);
  }
  FilterProject(data) {
    return axios.post('/seller/project/filterProject', data);
  }
  GetUserById(id) {
    return axios.post(`/admin/users/getUserDetails/${id}`);
  }

  getPrjectdetail(id) {
    return axios.get(`/seller/project/projectDetailget/${id}`);
  }
  getPrjectdetailfront(id) {
    return axios.get(`/projectDetailgetfront/${id}`);
  }
  getProjectsData(id) {
    return axios.get(`/getProjectsData/${id}`);
  }
  getDataForEditBid(project_name_id) {
    return axios.get(`/seller/freelancer/project/bid/edit/${project_name_id}`);
  }
  GetUser(id, pid) {
    return axios.get(`/seller/users/getsingleuser/${id}/${pid}`);
  }
  getbiddinguser() {
    return axios.get('/seller/project/getbiddinguser');
  }

  getProjectlistuser(fromDate, toDate, status, page, pagesize, search_key = '') {
    return axios.get(
      `/seller/project/getProjectlistuser/${fromDate}/${toDate}/${status}?page=${page}&pagesize=${pagesize}&search=${search_key}`
    );
  }

  getSkillCategory(CategoryId) {
    return axios.get(`/seller/project/getskillCategory/${CategoryId}`);
  }

  //re activate project after automatic deactivated by expired project
  reactivatePoject(data) {
    return axios.post(`/seller/project/reactivate`, data);
  }

  ProjectDelete(id) {
    return axios.delete(`/seller/project/ProjectDelete/${id}`);
  }

  updateProject(data) {
    return axios.post(`/seller/project/ProjectUpdate`, data);
  }

  // Bid User ///
  getBidUser(id, type) {
    return axios.get(`/seller/project/getUserBid/${id}/${type}`);
  }

  getBidUserfront(id) {
    return axios.get(`/getUserBid/${id}`);
  }

  getprojectlog(id) {
    return axios.get(`/getprojectlog/${id}`);
  }

  getbidusershortlist(id) {
    return axios.get(`/seller/project/getUsershortlist/${id}`);
  }

  //    getmessageusershortlisted(id){
  //     return axios.get(`/seller/project/getShortlistedUserProjectwise/${id}`);
  //    }

  // Order Cancellation Reasons
  GetOrderCancellationReasons() {
    return axios.get('cancellation_master/getCancelReasons');
  }

  // Seller's Revenue
  Revenue(data) {
    return axios.post('/seller/revenue', data);
  }
  RevenueHistory(data, page) {
    return axios.post(`/seller/revenueHistory?page=${page}`, data);
  }
  getWalletLedger(params = {}) {
    return axios.get('/seller/wallet/ledger', { params });
  }
  fundTransfer(data) {
    return axios.post('/seller/fundTransfer', data);
  }

  MessageForSeller(page) {
    return axios.get(`/seller/getMessagesForSeller?page=${page}`);
  }
  MessageForSent(page) {
    return axios.get(`/seller/MessageForSent?page=${page}`);
  }

  AllMessageConversation(MessageBy) {
    return axios.get(`/seller/getAllConversationMessage/${MessageBy}`);
  }
  mailunreadstatus() {
    return axios.get('/seller/unreadst');
  }
  ReadMessage(data) {
    return axios.post('/seller/readMessage', data);
  }
  InviteFrelacers(id) {
    return axios.get(`seller/project/invitefree/${id}`);
  }

  InvitedFrelacers(project_id, Invites) {
    return axios.get(`seller/project/invitedfree/${project_id}/${Invites}`);
  }

  // InvitedFrelacers(page,project_id,Invites){
  //     return axios.get(`seller/project/invitedfree/${project_id}/${Invites}?page=${page}`);
  // }

  PayForHireUser(data) {
    return axios.post('/seller/project/payformakeUserHire', data);
  }

  // ForContestHireUser(data)
  // {
  //     return axios.post('/seller/project/forContestUserHire',data);
  // }

  getbiduserdetail(id, uid) {
    return axios.get(`seller/project/getdetailuserget/${id}/${uid}`);
  }
  SearchAlluser(data) {
    return axios.post('/seller/project/searchAllUsers', data);
  }

  Userinvite(data) {
    return axios.post('/seller/project/Userinvite', data);
  }

  ShortlistUser(data) {
    return axios.post('/seller/project/Usershortlist', data);
  }

  Saveduser(data) {
    return axios.post('/seller/project/Usersaved', data);
  }
  Userhire(data) {
    return axios.post('/seller/project/Userhire', data);
  }

  Confirmpaymenthire(data) {
    return axios.post(`/seller/project/confirmpaymenthire`, data);
  }
  makeseetype(projectid, seetype) {
    return axios.get(`seller/project/Makeseetype/${projectid}/${seetype}`);
  }

  reuseinsertdata(data) {
    return axios.post(`seller/project/reusepost`, data);
  }

  getChatuser() {
    return axios.get('/seller/users/getAllchat');
  }
  getsearchchat(data) {
    return axios.post(`/seller/users/getsearchchat`, data);
  }
  getsearchchatconversation(data) {
    return axios.post(`/seller/users/getsearchchatconversation`, data);
  }
  recentstatus(data) {
    return axios.post(`/seller/users/recentstatus`, data);
  }
  gettotalcount() {
    return axios.get('/seller/users/gettotalcount');
  }

  getmilestonepayment(data) {
    return axios.post(`/seller/project/getmilestonepayment`, data);
  }

  // Confirmpaymenthire(data)
  // {
  //      return axios.post(`/seller/project/confirmpaymenthire`,data);
  // }

  ConfirmPaymentContest(data) {
    return axios.post(`/seller/project/confirm_payment_contest`, data);
  }

  //------------------------------------ Routes for Training Module ---------------------------------

  ShareClass(data) {
    return axios.post('/shareCourse', data);
  }

  GetPosts(id) {
    return axios.get(`/getPost/${id}`);
  }

  MakeDiscussion(data) {
    return axios.post('/post', data);
  }

  ReplyPost(data) {
    return axios.post('/reply_post', data);
  }
  LikePost(data) {
    return axios.post('/like_post', data);
  }

  // traningClasses(fromDate,toDate,status,user_id,callBy,page,pagesize){
  //     return axios.get(`/teacher/classes/training_classes/${fromDate}/${toDate}/${status}/${user_id}/${callBy}?page=${page}&pagesize=${pagesize}`);
  // }
  traningClasses(
    fromDate,
    toDate,
    user_id,
    page,
    pagesize,
    search,
    status,
    statusCount = false,
    resetDate,
    tutor
  ) {
    return axios.get(
      `/teacher/classes/training_classes/${fromDate}/${toDate}/${user_id}?page=${page}&pagesize=${pagesize}&search_key=${search}&status=${status}&status_count=${statusCount}&resetdate=${resetDate}&tutor=${tutor}`
    );
  }

  GetDraftClasses() {
    return axios.get(`/teacher/classes/mydrafts`);
  }
  GetClassById(classId) {
    return axios.get(`/teacher/classes/edit/${classId}`);
  }
  GetClass(classId) {
    return axios.get(`/teacher/classes/getClassVideos/${classId}`);
  }
  GetSequence(sectorpageId) {
    return axios.get(`/admin/domain/pagedesign/getSectorSequence/${sectorpageId}`);
  }
  GetCategorySequence(sectorpageId) {
    return axios.get(`/admin/domain/pagedesign/getCategorySequence/${sectorpageId}`);
  }
  GetEnrolledStudents(classId, page) {
    return axios.get(`/teacher/classes/enrolledStudent/${classId}?page=${page}`);
  }
  SendNotificationToStudent(data) {
    return axios.post('/teacher/classes/sendNotificationToStudent', data);
  }

  AddTrainingClass(data) {
    return axios.post('/teacher/classes/addClass', data);
  }
  UpdateTrainingClass(data) {
    return axios.post(`/teacher/classes/updateClass`, data);
  }
  DeletetrainingClass(id) {
    return axios.delete(`/teacher/classes/delete/${id}`);
  }

  AddClassDescription(data) {
    return axios.post('/teacher/classes/addClassDescription', data);
  }
  AddClassProject(data) {
    return axios.post('/teacher/classes/addClassProject', data);
  }
  UploadProjectAttachment(data) {
    return axios.post('/teacher/classes/uploadProjectFile', data);
  }

  UploadClassLecture(data, onUploadProgress) {
    // return axios.post('/teacher/classes/uploadClassVideo',data);
    // let len=this.uploadPercentage.length;

    return axios.post('/teacher/classes/uploadClassVideo', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    });
    //     headers: {
    //         'Content-Type': 'multipart/form-data'
    //     },
    //     onUploadProgress: function( progressEvent ) {
    //       this.videoProgress.per = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
    //       console.log('asdas', this.videoProgress);
    //     }.bind(this)
    //   }
    // ).then(function(){
    //   console.log('SUCCESS!!');
    //   this.uploadPercentage[len].status='Completed'
    // })
    // .catch(function(){
    //   console.log('FAILURE!!');
    // });
  }
  UpdateVideoSequence(data) {
    return axios.post('/teacher/classes/updateClassSequence', data);
  }

  UpdateSequence(data) {
    return axios.post('/admin/domain/pagedesign/updateSequence', data);
  }
  UpdateCategorySequence(data) {
    return axios.post('/admin/domain/pagedesign/updateCategorySequence', data);
  }
  updatVideoCaption(data) {
    return axios.post('/teacher/classes/updateVideoCaption', data);
  }
  deleteClassMedia(mediaId) {
    return axios.delete(`/teacher/classes/deleteClassMedia/${mediaId}`);
  }

  PublishTrainingClass(data) {
    return axios.post('/teacher/classes/publishClass', data);
  }

  GetActiveClassesByCategory(page, data) {
    return axios.post(`/teacher/classes/getActiveClass?page=${page}`, data);
  }
  SearchBrowseClass(data) {
    return axios.post(`/teacher/classes/searchClass`, data);
  }

  saveClass(data) {
    return axios.post(`/teacher/classes/saveClass`, data);
  }

  GetCourseReviews(class_id) {
    return axios.get(`/teacher/classes/getCourseReview/${class_id}`);
  }

  FilterClassReviewByTrainer(classid, status) {
    return axios.get(`/teacher/classes/filterClassReviewByTrainer/${classid}/${status}`);
  }
  LoadMoreClassReviewByTrainer(classid, status, page) {
    return axios.get(
      `/teacher/classes/filterClassReviewByTrainer/${classid}/${status}?page=${page}`
    );
  }

  TogglePostVisiable(data) {
    return axios.post(`/teacher/classes/toggleVisiableCoursePost`, data);
  }

  GetSavedClasses(category_id) {
    return axios.get(`/savedClasses/${category_id}`);
  }
  SearchSavedClass(data) {
    return axios.post(`/teacher/classes/searchSavedClass`, data);
  }

  GetInprogressClasses(category_id) {
    return axios.get(`/teacher/classes/inprogressClasses/${category_id}`);
  }
  SearchInprogressClass(data) {
    return axios.post(`/teacher/classes/searchInprogressClass`, data);
  }

  MarkClassComplete(data) {
    return axios.post(`/teacher/classes/completeClass`, data);
  }

  GetCompletedClasses(category_id) {
    return axios.get(`/teacher/classes/completedClasses/${category_id}`);
  }
  SearchCompletedClass(data) {
    return axios.post(`/teacher/classes/searchCompletedClass`, data);
  }

  followUpTraining(data) {
    return axios.post(`/training_follow`, data);
  }

  ViewsTraining(data) {
    return axios.post(`/trainingView`, data);
  }

  leaveReview(data) {
    return axios.post(`/submitReview`, data);
  }
  EditReview(id) {
    return axios.get(`/editReview/${id}`);
  }
  UpdateReview(data) {
    return axios.post(`/updateReview`, data);
  }
  FilterClassReview(classid, status) {
    return axios.get(`/filterClassReview/${classid}/${status}`);
  }
  LoadMoreClassReview(classid, status, page) {
    return axios.get(`/filterClassReview/${classid}/${status}?page=${page}`);
  }

  //whatsapp message

  getwhatsappmessage(leadId) {
    return axios.get(`/admin/whatsappmessage/${leadId}`);
  }
  getcontact_message(data) {
    return axios.get(`/admin/get_contacts`, data);
  }
  getTemplates_message(data) {
    return axios.get(`/admin/get_templates`, data);
  }

  getUserIdByLead(lead_id) {
    return axios.get(`/admin/get-user-id-by-lead/${lead_id}`);
  }

  getContactIdByUserId(user_id) {
    return axios.get(`/admin/get-contact-id-by-user/${user_id}`);
  }

  sendWhatsAppTemplate(data) {
    return axios.post(`/admin/sendtemplate`, data);
  }

  sendWhatsappmessage(data) {
    return axios.post(`/admin/crm/send/whatsapp`, data);
  }
  whatsAppTemplates() {
    return axios.get(`/admin/crm/whatsapp/templates`);
  }

  // Master for Subscription Charges
  getSubscriptionCharges(page, pagesize) {
    return axios.get(`/admin/subscription_charges?page=${page}&pagesize=${pagesize}`);
  }

  getSubscriptionChargesByID(id) {
    return axios.get(`/admin/subscription_charges/edit/${id}`);
  }
  addSubscriptionCharges(data) {
    return axios.post('/admin/subscription_charges/add', data);
  }
  updateSubscriptionCharges(id, data) {
    return axios.post(`/admin/subscription_charges/update/${id}`, data);
  }
  deleteSubscriptionCharges(id) {
    return axios.delete(`/admin/subscription_charges/delete/${id}`);
  }
  SubscriptionActiveStatusToggle(id) {
    return axios.post(`/admin/subscription_charges/deactivate/${id}`);
  }

  fetchnotification() {
    return axios.get('/seller/users/fetchnotification');
  }
  readonmessage(data) {
    return axios.post('/seller/users/readonmessage/', data);
  }
  getnotification() {
    return axios.post('/seller/users/notificationget/');
  }
  deletemessagenot(id) {
    return axios.delete(`/seller/users/deletemessagenot/${id}`);
  }

  // admin get notification user //
  getusernotification(data) {
    return axios.post('/admin/getusernotification', data);
  }
  AddNotification(data) {
    return axios.post('/admin/notification/AddNotification', data);
  }
  getreportnotification(fromDate, toDate, page, pagesize, userType) {
    //return axios.get("/admin/notification/getreportnotification/");
    return axios.post(
      `/admin/notification/getreportnotification/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&usertype=${userType}`
    );
  }

  getreportuser(id, page) {
    return axios.get(`/admin/notification/getreportuser/${id}?page=${page}`);
  }
  Filterusertype(data) {
    return axios.post(`/admin/notification/Filterusertype`, data);
  }
  filteruserdate(data) {
    return axios.post(`/admin/notification/filteruserdate`, data);
  }

  // CRM Api
  crmBDEReport(from, to, page, pagesize) {
    return axios.get(
      `/admin/crm/bde/report?page=${page}&pagesize=${pagesize}&to=${to}&from=${from}`
    );
  }

  citiesList() {
    return axios.get('/admin/crm/cities');
  }
  crmReports(page, pagesize, filter, key) {
    return axios.get(
      `/admin/crm/report/get?page=${page}&pagesize=${pagesize}&representative=${filter.representative}&campaign=${filter.campaign}&source=${filter.source}&status=${filter.status}&user_type=${filter.user}&lead_type=${filter.userType}&fresh=${filter.freshUser}&experience=${filter.experience}&unassigned=${filter.unassignedLead}&userappinstalled=${filter.appinstalled}&followupdate=${filter.followupdate}&m_varified=${filter.mobile}&remark=${filter.remark}&note_remark=${filter.note_remark}&category=${filter.category}&from_date=${filter.fromDate}&to_date=${filter.toDate}&keyword=${key}&starmarked=${filter.starmarked}`
    );
  }
  crmActiveUser(page, pagesize) {
    return axios.get(`/admin/crm/master/activeuser?page=${page}&pagesize=${pagesize}`);
  }
  crmimporant(id) {
    return axios.get(`/admin/crm/important?leadid=${id}`);
  }
  getLeadDetails(id) {
    return axios.get(`/admin/crm/lead/details/get/${id}`);
  }
  updateCrmLead(id, data) {
    return axios.post(`/admin/crm/lead/update/lead_details/${id}`, data);
  }
  //lead
  createleadturbo(data) {
    return axios.post(`/admin/crm/turbo/create`, data);
  }
  getLeadData(leadId) {
    return axios.get(`/admin/crm/turbo/fetch/${leadId || ''}`);
  }
  updateLeadTurbo(leadId, data) {
    return axios.post(`/admin/crm/turbo/update/${leadId}`, data);
  }
  checkLeadId(leadId) {
    return axios.get(`/admin/crm/turbo/checkleadid/${leadId}`);
  }

  getLeadNotes(id, page, pagesize = 10) {
    return axios.get(`/admin/crm/lead/note/get/${id}?page=${page}&pagesize=${pagesize}`);
  }
  createLeadNote(data) {
    return axios.post(`/admin/crm/lead/note/create`, data);
  }
  updateLeadNote(data) {
    return axios.post(`/admin/crm/lead/note/update`, data);
  }
  AddCrmLeadsSave(data) {
    return axios.post(`/admin/crm/lead/manuale/store`, data);
  }
  userTempData(data) {
    return axios.post(`/admin/crm/lead/unregistered/store`, data);
  }
  uploadLeadBulkStore(data) {
    return axios.post(`/admin/crm/lead/bulk_uploadlead/store`, data);
  }

  AddUserPlatformChargeSave(data) {
    return axios.post(`/admin/accounting/platformcharge/store`, data);
  }

  crmMasterData(data) {
    return axios.post(`/admin/crm/master/get`, data);
  }

  getnotifications(page, data, pagesize) {
    return axios.post(`/admin/crm/notification/get?page=${page}&pagesize=${pagesize}`, data);
  }
  savenotification(data) {
    return axios.post(`/admin/crm/notification/save`, data);
  }
  followupnotification() {
    return axios.post(`/admin/followup/notification`);
  }
  checknotification() {
    return axios.post(`/admin/followup/check`);
  }
  //for new folloup
  StoreFollowup(data) {
    return axios.post(`/admin/crm/lead/data/followup`, data);
  }
  getfollowups(id, page, pagesize, search) {
    return axios.get(
      `/admin/crm/lead/followup/get/${id}?page=${page}&pagesize=${pagesize}&search_key=${search}`
    );
  }

  updateFollowupStatus(data) {
    return axios.post(`/admin/crm/lead/followup/update/status`, data);
  }

  // setup default Representatives

  createDefaultRepres(data) {
    return axios.post(`/admin/crm/master/default/user/add`, data);
  }
  updateDefaultRepres(data) {
    return axios.post(`/admin/crm/master/default/user/update`, data);
  }

  getDefaultRepres(page) {
    return axios.get(`/admin/crm/master/default/user/get?page=${page}`, data);
  }
  deleteDefaultRepres(id) {
    return axios.delete(`/admin/crm/master/default/user/delete/${id}`);
  }

  crmSourceForDefault() {
    return axios.get(`/admin/crm/master/default/source/get`);
  }

  //convert lead to user
  createUserFromLead(data) {
    return axios.post(`/admin/crm/user/create`, data);
  }
  //create lead from

  createLeadFromCall(data) {
    return axios.post(`/admin/crm/lead/create`, data);
  }

  //Email
  getSentEmail(id, page) {
    return axios.get(`/admin/crm/lead/email/send/get/${id}?page=${page}`);
  }
  sendEmail(data) {
    return axios.post(`/admin/crm/lead/email/send`, data);
  }

  getLeadTimeline(id, page) {
    return axios.get(`/admin/crm/lead/timeline/get/${id}?page=${page}`);
  }

  updateLeadData(data) {
    return axios.post(`/admin/crm/lead/data/update`, data);
  }

  getUserByManager() {
    return axios.get('/admin/crm/admin/userbymanager');
  }
  getLeadSummay(page, obj) {
    return axios.post(`/admin/crm/summary/get?page=${page}`, obj);
  }
  changeUserTypeCrm(data) {
    return axios.post(`/admin/crm/change_user_type`, data);
  }
  changeUserTypeUserNotRegister(data) {
    return axios.post(`/admin/crm/change_lead_user/user_type`, data);
  }

  getCallLog(data, page) {
    return axios.post(`/admin/crm/call/log?page=${page}`, data);
  }

  getMyOperatorUser(number = 0, page = 1) {
    return axios.get(`/admin/crm/call/user/get?number=${number}&page=${page}`);
  }

  refreshCallLogs(number = 0) {
    return axios.get(`/admin/crm/call/get/refresh?number=${number}`);
  }

  callRecordingLink(file) {
    return axios.get(`/admin/crm/call/get/recording/${file}`);
  }

  // lead call
  getLeadCall(type, page, data) {
    return axios.post(`/admin/crm/lead/call/${type}/get?page=${page}`, data);
  }

  connetCall(data) {
    return axios.post(`/admin/crm/lead/call/create`, data);
  }
  clicktocalltata(data) {
    return axios.post(`/admin/crm/lead/call/createtata`, data);
  }

  // getDraftEmail(id,page){
  //     return axios.get(`/admin/crm/details/email/get/draftemail/${id}?page=${page}`)
  // }
  // getSentEmail(id,page){
  //     return axios.get(`/admin/crm/details/email/get/sentemail/${id}?page=${page}`)
  // }
  // storeEmail(data){
  //     return axios.post(`/admin/crm/details/email/add`,data);
  // }
  // draftUpdate(id,data){
  //     return axios.post(`/admin/crm/details/email/update/draftupdate/${id}`,data);
  // }
  // emailDelete(id){
  //     return axios.delete(`/admin/crm/details/email/delete/${id}`)
  // }

  //lead status
  allLeadStatus() {
    return axios.get(`/admin/crm/master/leadstatus/all`);
  }
  getLeadStatus(page, pagesize) {
    return axios.get(`/admin/crm/master/leadstatus/get?page=${page}&pagesize=${pagesize}`);
  }
  // login Logs
  getLoginLog(page, pagesize, selected, from_date, to_date) {
    return axios.get(
      `/admin/crm/master/login-log?page=${page}&pagesize=${pagesize}&select=${selected}&from_date=${from_date}&to_date=${to_date}`
    );
  }
  getlogactivities(page, pagesize, selected, selected_module, fromDate, toDate, search) {
    return axios.get(
      `/admin/crm/master/log_activities/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&select=${selected}&module=${selected_module}&search_key=${search}`
    );
  }
  addLeadStatus(data) {
    return axios.post(`/admin/crm/master/leadstatus/add`, data);
  }
  updateLeadStatus(id, data) {
    return axios.post(`/admin/crm/master/leadstatus/update/${id}`, data);
  }
  deleteLeadStatus(id) {
    return axios.delete(`/admin/crm/master/leadstatus/delete/${id}`);
  }

  //lead campaign

  allLeadCampaigns() {
    return axios.get(`/admin/crm/master/leadcampaign/all`);
  }
  getLeadCampaign(page, pagesize) {
    return axios.get(`/admin/crm/master/leadcampaign/get?page=${page}&pagesize=${pagesize}`);
  }
  addLeadCampaign(data) {
    return axios.post(`/admin/crm/master/leadcampaign/add`, data);
  }
  updateLeadCampaign(id, data) {
    return axios.post(`/admin/crm/master/leadcampaign/update/${id}`, data);
  }
  deleteLeadCampaign(id) {
    return axios.delete(`/admin/crm/master/leadcampaign/delete/${id}`);
  }
  //lead source

  allLeadSources() {
    return axios.get(`/admin/crm/master/leadsource/all`);
  }
  getLeadSource(page, pagesize) {
    return axios.get(`/admin/crm/master/leadsource/get?page=${page}&pagesize=${pagesize}`);
  }
  addLeadSource(data) {
    return axios.post(`/admin/crm/master/leadsource/add`, data);
  }
  updateLeadSource(id, data) {
    return axios.post(`/admin/crm/master/leadsource/update/${id}`, data);
  }
  deleteLeadSource(id) {
    return axios.delete(`/admin/crm/master/leadsource/delete/${id}`);
  }

  //lead remark
  allLeadRemark() {
    return axios.get(`/admin/crm/master/leadremark/all`);
  }

  allCategories() {
    return axios.get(`/admin/crm/master/leadcategories/all`);
  }

  getLeadRemark(page, pagesize) {
    return axios.get(`/admin/crm/master/leadremark/get?page=${page}&pagesize=${pagesize}`);
  }
  addLeadRemark(data) {
    return axios.post(`/admin/crm/master/leadremark/add`, data);
  }
  updateLeadRemark(id, data) {
    return axios.post(`/admin/crm/master/leadremark/update/${id}`, data);
  }
  deleteLeadRemark(id) {
    return axios.delete(`/admin/crm/master/leadremark/delete/${id}`);
  }

  GetProfilePercent(userid) {
    return axios.get(`/seller/users/getprofilePercent/${userid}`);
  }

  GetCoinsetup() {
    return axios.get('/admin/GetCoinsetup');
  }

  addCoinSetup(data) {
    return axios.post('/admin/coinsetup/add', data);
  }
  UpdateCoinSetup(id, data) {
    return axios.post(`/admin/coinsetup/update/${id}`, data);
  }
  getcoincount() {
    return axios.get('/seller/users/getcoincount');
  }

  getcoindetail(fromDate, toDate, trans_type, page, pagesize) {
    return axios.get(
      `/seller/users/getcoindetail/${fromDate}/${toDate}/${trans_type}?page=${page}&pagesize=${pagesize}`
    );
  }

  zoommeetingdata() {
    return axios.get('/seller/users/zoommeetingdata');
  }
  monitor(fromDate, toDate) {
    return axios.get(`/admin/dashboard/${fromDate}/${toDate}`);
  }
  getadminDashboard(fromDate, toDate) {
    return axios.get(`/admin/newdashboard/${fromDate}/${toDate}`);
  }
  getDashboardProject(fromDate, toDate) {
    return axios.get(`/admin/projectdashboard/${fromDate}/${toDate}`);
  }

  getDashboardUser(fromDate, toDate) {
    return axios.get(`/admin/userdashboard/${fromDate}/${toDate}`);
  }

  getDashboardProfileCompletion(fromDate, toDate) {
    return axios.get(`/admin/profilecompletion/${fromDate}/${toDate}`);
  }

  getDashboardBrowseandBuy(fromDate, toDate) {
    return axios.get(`/admin/dashboard/browseandbuy/${fromDate}/${toDate}`);
  }

  DashboardTrainingVideos(fromDate, toDate) {
    return axios.get(`/admin/dashboard/trainingvideos/${fromDate}/${toDate}`);
  }

  getDashboardOrders(fromDate, toDate) {
    return axios.get(`/admin/dashboard/orders/${fromDate}/${toDate}`);
  }

  getDashboardPayouts(fromDate, toDate) {
    return axios.get(`/admin/dashboard/payouts/${fromDate}/${toDate}`);
  }

  getDashboardLead(fromDate, toDate) {
    return axios.get(`/admin/dashboard/lead/${fromDate}/${toDate}`);
  }

  getDashboardFreelancer() {
    return axios.get(`/admin/dashboard/top_freelancer`);
  }

  getDashboardClient() {
    return axios.get(`/admin/dashboard/top_client`);
  }

  getDashboardCallLog(fromDate, toDate) {
    return axios.get(`/admin/dashboard/call_log/${fromDate}/${toDate}`);
  }
  getadmindatareport(fromDate, toDate, heading, pagesize, page) {
    return axios.get(
      `/admin/newdashboardreport/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&heading=${heading}`
    );
  }

  getLeadSummayfordashboard(fromDate, toDate) {
    return axios.get(`/admin/newdashboard/summary/get/${fromDate}/${toDate}`);
  }

  UserDashboardReport(fromDate, toDate) {
    return axios.get(`/seller/users/dashboardReport/${fromDate}/${toDate}`);
  }
  getClientDashboard() {
    return axios.get(`/seller/client/dashboardRecordGet`);
  }

  FetchDomainOrder() {
    return axios.get(`admin/domain/fetchorder`);
  }

  //
  getFreelancerDashboard() {
    return axios.get(`/seller/freelancer/dashboardRecordGet`);
  }
  getClientDashboarddata(page, pagesize, heading) {
    return axios.get(
      `/seller/client/dashboardRecordData?page=${page}&pagesize=${pagesize}&heading=${heading}`
    );
  }
  changeusertype(data) {
    return axios.get(`/seller/freelancer/update/usertype?type=${data}`);
  }

  StudentDashboardDetails(fromDate, toDate) {
    return axios.get(`/student/StudentDashboardDetails?from=${fromDate}&to=${toDate}`);
  }

  TutorDashboardDetails(fromDate, toDate) {
    return axios.get(`/tutor/TutorDashboardDetails?from=${fromDate}&to=${toDate}`);
  }

  GetAllSubscriptionPacks(packType) {
    return axios.get(`/teacher/classes/allSubscriptions?type=${packType}`);
  }

  AddSubscriptionPack(data) {
    return axios.post('/student/save/subscription', data);
  }
  GetSubCartdata() {
    return axios.get('/student/sub/data');
  }
  subscriptionPayment(type, data) {
    return axios.post(`/student/sub/payment/${type}`, data);
  }
  ApplyDiscountCoupon(data) {
    return axios.post('/student/save/discount', data);
  }
  PostClassComment(data) {
    return axios.post('/student/save/comment', data);
  }
  videoWatchTimeStore(data) {
    return axios.post('tutor/browse/class/video/watch_time', data);
  }

  EnrollStudent(id) {
    return axios.get(`/student/save/enroll/${id}`);
  }
  inProgessClass(class_id, lesson_id) {
    return axios.get(`/student/in_progress/save/${class_id}/${lesson_id}`);
  }
  GetClassRating(id) {
    return axios.get(`/student/get/rating/${id}`);
  }
  AddSubscriptionData(data) {
    return axios.post('/student/sub/save', data);
  }
  SocialLogin(data) {
    return axios.get(`/oauth/${data}`);
  }
  deleteemail(data) {
    return axios.post('/seller/users/deletemail', data);
  }

  getuserdata(data) {
    return axios.post('/users/getemail', data);
  }

  resetpassword(data) {
    return axios.post('/forgetpassword', data);
  }
  newpasswordsave(data) {
    return axios.post('/userresetpasswordstore', data);
  }

  newusercreate(data) {
    return axios.post('/newusersave', data);
  }

  registeruser(data) {
    return axios.post('/registeruser', data);
  }
  registeruseronsignup(data) {
    return axios.post('/registeruseronsignup', data);
  }

  // login user fullname
  getLoginUserFullname() {
    return axios.get('/get/login_user/name');
  }

  registerusertype(data) {
    return axios.post('/registerusertype', data);
  }

  updateuserdata(id, data) {
    return axios.post(`/updateuserdata/${id}`, data);
  }

  emailvalid(data) {
    return axios.post('/emailvalid', data);
  }

  verifyPanDetails(panData) {
    return axios.get('/tutor/profile/pantest', {
      params: panData,
    });
  }

  verifyClientPanDetails(panData) {
    return axios.get('/pantest', {
      params: panData,
    });
  }

  SellerPanDetailsVerify(panData) {
    return axios.get('/seller/freelancer/profile/pantest', {
      params: panData,
    });
  }

  gstUsingPan(panData, state) {
    return axios.get('/seller/freelancer/profile/gstfetch', {
      params: {
        ...panData,
        state: state,
      },
    });
  }
  //new api for admin panel

  getadminusers() {
    return axios.get(`/admin/ticketTypes/getadminusers`);
  }
  chatMonitorByAdmin(fromDate, toDate, search_key, page, pagesize, showFile) {
    return axios.get(
      `/admin/monitor/chat/get?page=${page}&pagesize=${pagesize}&isfile=${showFile}&from=${fromDate}&to=${toDate}&search=${search_key}`
    );
  }
  chatMonitorByAdminMoreDetails(obj) {
    return axios.post(`/admin/monitor/chat/get/more`, obj);
  }
  BidMonitorByAdmin(fromDate, toDate, search_key, page, pagesize, status, bid_id) {
    return axios.get(
      `/admin/monitor/bid/get?page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}&bid_id=${bid_id}&status=${status}&search=${search_key}`
    );
  }
  bidDetailsForAdmin(project_slug, user_name) {
    return axios.get(`/admin/monitor/bid/details/${project_slug}/${user_name}`);
  }
  updateBidStatus(data) {
    return axios.post(`/admin/monitor/bid/update/status`, data);
  }

  chatDetailForAdmin(room_type, room_id, sender_id, type) {
    return axios.get(
      `/admin/monitor/chat/details?room_type=${room_type}&room_id=${room_id}&sender_id=${sender_id}&type=${type}`
    );
  }

  //new api for client panel

  clientProjectList(
    resetDate,
    fromDate,
    toDate,
    status,
    page,
    pagesize,
    search_key = '',
    statusCount = false
  ) {
    return axios.get(
      `/seller/client/project/report/${status}?page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}&resetdate=${resetDate}&search=${search_key}&status_count=${statusCount}`
    );
  }
  // createProjectByClient(data) {
  //     return axios.post(`/seller/client/project/create`, data);

  // }
  saveProjectByClient(data) {
    return axios.post(`/seller/client/project/create`, data);
  }
  clientProjectstatus(type, id) {
    return axios.post(`seller/client/project/status/${type}/${id}`);
  }
  editClientProject(id) {
    return axios.get(`/seller/client/project/edit/${id}`);
  }
  getBidMilestonesByProject(project_id) {
    return axios.get(`/seller/client/project/milestones/${project_id}`);
  }

  projectPreviewBeforeSubmit(id) {
    return axios.post(`/seller/client/project/submit/preview/${id}`);
  }

  postStandardProject(data) {
    return axios.post('/seller/client/project/standard/post', data);
  }
  paymentForContest(type, data) {
    return axios.post(`/seller/client/project/contest/payment/${type}`, data);
  }
  getclientaccounts(
    tabs,
    resetDate,
    fromDate,
    toDate,
    status,
    page,
    pagesize,
    search_key = '',
    statusCount = false
  ) {
    return axios.get(
      `/seller/client/account/${status}?tab_type=${tabs}&resetDate=${resetDate}&page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}&search=${search_key}&status_count=${statusCount}`
    );
  }

  getfreelanceraccounts(resetDate, fromDate, toDate, page, pagesize, search_key = '') {
    return axios.get(
      `/seller/freelancer/order/payment_invoice/?resetDate=${resetDate}&page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}&search=${search_key}`
    );
  }

  getRegisteredGSTDetails(resetDate, fromDate, toDate, page, pagesize, search_key = '', type) {
    return axios.get(
      `/seller/freelancer/gstreport/?resetDate=${resetDate}&page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}&search=${search_key}&type=${type}`
    );
  }

  getTcsDetails(fromDate, toDate, page, pagesize) {
    return axios.get(
      `/admin/tax/tcs_report/?page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}`
    );
  }
  getTdsDetails(fromDate, toDate, page, pagesize) {
    return axios.get(
      `/admin/tax/tds_report/?page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}`
    );
  }

  getAdminGstReport(fromDate, toDate, page, pagesize, type) {
    return axios.get(
      `/admin/tax/gst_report/?page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}&type=${type}`
    );
  }

  projectDetailsForClient(id) {
    return axios.get(`/seller/client/project/details/${id}`);
  }
  freelancerForProjectInvite(id, status, page, pagesize, search_key = '') {
    return axios.get(
      `/seller/client/project/freelancers/${id}/${status}?page=${page}&pagesize=${pagesize}&search=${search_key}`
    );
  }
  updateUserSaveStatus(userName, status, projectNameId) {
    return axios.get(
      `/seller/client/project/freelancer/save/${projectNameId}/${status}/${userName}`
    );
  }
  updateProposalSaveStatus(bid_id, status, projectNameId) {
    return axios.get(`/seller/client/project/proposal/save/${projectNameId}/${status}/${bid_id}`);
  }

  isFreelancerGstReg(userId) {
    return axios.get(`/seller/client/project/freelancer/${userId}/gst-check`);
  }

  inviteForProject(userName, data) {
    return axios.post(`/seller/client/project/freelancer/invite/${userName}`, data);
  }

  freelancerDetailsWithProject(projectNameId, userName) {
    return axios.get(`/seller/client/project/freelancer/details/${projectNameId}/${userName}`);
  }

  getProposalOfProject(projectNameId, page, status, search_key) {
    return axios.get(
      `/seller/client/project/proposals/${projectNameId}?page=${page}&status=${status}&search_key=${search_key}`
    );
  }
  getFiveNotification() {
    return axios.get(`/seller/client/letest_five_notification`);
  }

  projectProposalDetails(projectNameId, userName) {
    return axios.get(`/seller/client/project/proposals/details/${projectNameId}/${userName}`);
  }
  updateMilestoneProposal(data) {
    return axios.post(`/seller/client/project/proposals/update/milestone`, data);
  }
  getClientProjectList() {
    return axios.get(`/seller/client/project/list`);
  }

  addTicketNew(data) {
    return axios.post(`/seller/ticket/store`, data);
  }

  addprojectticket(project_id) {
    return axios.post(`/seller/project/ticket/store?project_id=${project_id}`);
  }

  getopenTicketdata(page, pagesize) {
    return axios.get(`/seller/openticket?page=${page}&pagesize=${pagesize}`);
  }
  getopenTickepaginatetdata(page, pagesize) {
    return axios.get(`/seller/openticket/paginate?page=${page}&pagesize=${pagesize}`);
  }
  getcloseTicketpaginatedata(page, pagesize) {
    return axios.get(`/seller/closeticket/paginate?page=${page}&pagesize=${pagesize}`);
  }

  getmessagesupport(ticket_id) {
    return axios.get(`/seller/getmessage?ticket_id=${ticket_id}`);
  }
  messagemarkread(ticket_id) {
    return axios.get(`/seller/messagemarkread?ticket_id=${ticket_id}`);
  }
  sendmessagenew(data) {
    return axios.post(`/seller/sendmessagenew`, data);
  }

  paymentForStandard(type, data) {
    return axios.post(`/seller/client/project/standard/payment/${type}`, data);
  }

  partialPaymentForStandard(type, data) {
    return axios.post(`/seller/client/project/partial/payment/${type}`, data);
  }

  hireForContest(data) {
    return axios.post(`/seller/client/project/contest/hire`, data);
  }

  detailForHireProject(id) {
    return axios.get(`/seller/client/project/hire/details/${id}`);
  }

  paymentDetailsHiredProject(id, type) {
    return axios.get(`/seller/client/project/hire/payment/details/${id}/${type}`);
  }

  acceptProject(data) {
    return axios.post('/seller/client/project/hire/accept/project', data);
  }
  requestRevisionProject(data) {
    return axios.post('/seller/client/project/hire/revision/project', data);
  }

  updateHireOrderStatus(data) {
    return axios.post('/seller/client/project/hire/change/order/status', data);
  }

  //
  // get review
  Review(type, id) {
    return axios.get(`/seller/review/get/${type}/${id}`);
  }
  //talent new api

  getTalentsForClient(data) {
    return axios.post(`/seller/client/talent/get`, data);
  }

  talentDetails(userName) {
    return axios.get(`/seller/client/talent/details/${userName}`);
  }

  getMoreFreelancerPortfolio(userId, page) {
    return axios.get(`/seller/client/talent/portfolios/${userId}?page=${page}`);
  }
  getMoreFreelancerReviews(userId, page) {
    return axios.get(`/seller/client/talent/reviews/${userId}?page=${page}`);
  }

  clientProcessingFee() {
    return axios.get(`/seller/client/additional/data/pay/fee`);
  }

  getChatRooms() {
    return axios.get(`/seller/chat/room/get/all`);
  }

  sendMessageByChatRoom(data) {
    return axios.post(`/seller/chat/room/message/send`, data);
  }
  getChatByRoom(id, room_type) {
    return axios.get(`/seller/chat/room/message/get/${id}/${room_type}`);
  }

  getChatRoomByUser(user_id) {
    return axios.get(`/seller/chat/room/byuser/${user_id}`);
  }

  getRoomByProject(id) {
    return axios.get(`/seller/chat/room/byproject/${id}`);
  }
  getChatRoomFiles(id, type, page = 1) {
    return axios.get(`/seller/chat/room/file/get/${id}/${type}?page=${page}`);
  }

  getUserRelatedWork(id, page) {
    return axios.get(`/seller/work/get/${id}?page=${page}`);
  }

  // new api for freelancer
  updateProjectMilestoneByFreelancer(project_id, bid_id, type) {
    return axios.get(`/seller/freelancer/project/proposal/update/${project_id}/${bid_id}/${type}`);
  }
  deliveredProject(data) {
    return axios.post('/seller/freelancer/project/hire/delivered/project', data);
  }

  TermAndConditionForFreelancer(type) {
    return axios.get(`/seller/freelancer/terms_and_condition/get/${type}`);
  }

  findProject(data) {
    return axios.post('/seller/freelancer/project/find', data);
  }
  savedFindProject(data) {
    return axios.post('/seller/freelancer/project/find/saved_project', data);
  }
  invitesFindProject(data) {
    return axios.post('/seller/freelancer/project/find/invites_project', data);
  }
  hiredFindProject(data) {
    return axios.post('/seller/freelancer/project/find/hired_project', data);
  }
  submitedProposalFindProject(data) {
    return axios.post('/seller/freelancer/project/find/submited_proposal_project', data);
  }
  SavedProject(data) {
    return axios.post('/seller/freelancer/project/save', data);
  }
  projectInfoByFreelancer(data) {
    return axios.get(`/seller/freelancer/project/info/${data}`);
  }
  projectBidByFreelancer(data) {
    return axios.get(`/seller/freelancer/project/bides/${data}`);
  }
  projectBidFormData(data, type) {
    return axios.get(`/seller/freelancer/project/bids/formdata/${data}/${type}`);
  }

  //23/03/2023
  submitBidByFreelancer(data) {
    return axios.post(`/seller/freelancer/project/bid/submit`, data);
  }

  resubmitBidByFreelancer(data) {
    return axios.post(`/seller/freelancer/project/bid/resubmit`, data);
  }

  updateBidByFreelancer(data) {
    return axios.post(`/seller/freelancer/project/bid/update`, data);
  }

  detailForHireProjectForFreelancer(id) {
    return axios.get(`/seller/freelancer/project/hire/details/${id}`);
  }

  paymentDetailsHiredProjectForFreelancer(id, type) {
    return axios.get(`/seller/freelancer/project/hire/payment/details/${id}/${type}`);
  }

  FreelancerBrowseAndBuyLists(
    page,
    pagesize,
    search_key = '',
    fromDate,
    toDate,
    resetDate,
    statusTypeFilter,
    statusCount = false
  ) {
    return axios.get(
      `/seller/freelancer/browse_and_buy/get_browse_and_buy_list?page=${page}&pagesize=${pagesize}&search=${search_key}&from=${fromDate}&to=${toDate}&resetdate=${resetDate}&status=${statusTypeFilter}&status_count=${statusCount}`
    );
  }
  FreelancerBrowseAndBuyDelete(del) {
    return axios.delete(`/seller/freelancer/browse_and_buy/get_browse_and_buy_delete/${del}`);
  }
  FreelancerBrowseAndBuyActive(id) {
    return axios.get(`/seller/freelancer/browse_and_buy/get_browse_and_buy_change_status/${id}`);
  }
  FreelancerBrowseAndBuyListsDraft(page, pagesize) {
    return axios.get(
      `/seller/freelancer/browse_and_buy/get_browse_and_buy_list_draft?page=${page}&pagesize=${pagesize}`
    );
  }
  getSingleBrowseAndBuy(id) {
    return axios.get(`/seller/freelancer/browse_and_buy/preview/${id}`);
  }

  // creating browse_and_buy by freelancer
  AddBrowseAndBuy(data) {
    return axios.post(`/seller/freelancer/browse_and_buy/add`, data);
  }

  UpdateBrowseAndBuyDescription(id, data) {
    return axios.post(`/seller/freelancer/browse_and_buy/description/update/${id}`, data);
  }
  AddBrowseAndBuyGallery(data) {
    return axios.post(`/seller/freelancer/browse_and_buy/addGallery`, data);
  }

  EditBrowseAndBuy(ProposalID) {
    return axios.post(`/seller/freelancer/browse_and_buy/formData/${ProposalID}`);
  }
  publishBrowseAndBuy(data) {
    return axios.post('/seller/freelancer/browse_and_buy/publish', data);
  }
  // UpdateOverView(ProposalID,data)
  // {
  //     return axios.post(`/seller/proposals/updateOverview/${ProposalID}`,data);
  // }

  // AddPackages(data)
  // {
  //     return axios.post(`/seller/proposals/addPackages`,data);
  // }
  // UpdatePackages(data)
  // {
  //     return axios.post('/seller/proposals/updatePackages',data);
  // }

  // findStandardProject(data){
  //     return axios.post('/seller/freelancer/project/find/',data);

  // }

  getuserdetails() {
    return axios.get(`/seller/freelancer/profile/get`);
  }
  getuserskills() {
    return axios.get(`/seller/freelancer/profile/get/skills`);
  }
  adduserskills(data) {
    return axios.post(`/seller/freelancer/profile/get/addskills`, data);
  }
  deleteuserskills(data) {
    return axios.post(`/seller/freelancer/profile/get/deleteskills`, data);
  }
  getlanguage() {
    return axios.get(`/seller/freelancer/profile/getlanguage`);
  }
  saveuserlanguage(data) {
    return axios.post(`/seller/freelancer/profile/saveuserlanguage`, data);
  }
  saveuserbasicdetail(data) {
    return axios.post(`/seller/freelancer/profile/updateuserdetail`, data);
  }

  UpdateStepOneDetails(data) {
    return axios.post(`/seller/freelancer/profile/updatefirstdetail`, data);
  }

  UpdateStepSecondDetails(data) {
    return axios.post(`/seller/freelancer/profile/updateseconddetail`, data);
  }

  UpdateStepThirdDetails(data) {
    return axios.post(`/seller/freelancer/profile/updatethirddetail`, data);
  }

  UpdateStepFourthDetails(data) {
    return axios.post(`/seller/freelancer/profile/updatefourthdetail`, data);
  }

  deleteobj(data) {
    return axios.post(`/seller/freelancer/profile/get/deleteobj`, data);
  }

  deleteaccount(data) {
    return axios.post(`/seller/freelancer/profile/delete`, data);
  }
  otpVarificationdelete(data) {
    return axios.post(`/account/mobile/account/delete/varification`, data);
  }
  verifyMobileOtptorecover(data) {
    return axios.post(`/account/mobile/account/recover/varification`, data);
  }

  getOrderForFreelancer(
    type,
    resetDate,
    from_date,
    to_date,
    statusTypeFilter,
    currentPage,
    selectedPageSize,
    search,
    statusCount
  ) {
    return axios.get(
      `/seller/freelancer/orders/get?type=${type}&reset_data=${resetDate}&from_date=${from_date}&to_date=${to_date}&statusTypeFilter=${statusTypeFilter}&page=${currentPage}&pagesize=${selectedPageSize}&search=${search}&statusCount=${statusCount}`
    );
  }

  //Tutor API
  getTutorList() {
    return axios.get(`tutor/class/mentor/get`);
  }

  getClassDetailsFrontend(id) {
    return axios.get(`/get_class_details_frontend_page/${id}`);
  }
  createClassbyTutor(data) {
    return axios.post(`tutor/class/create/store`, data);
  }
  tutorClassReport(fromDate, toDate, status, page, pagesize, search_key = '', statusCount = false) {
    return axios.get(
      `/tutor/class/report/${status}?page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}&search=${search_key}&status_count=${statusCount}`
    );
  }

  getTutorClassByid(id) {
    return axios.get(`tutor/class/edit/get/${id}`);
  }
  updateClassTutor(data) {
    return axios.post(`tutor/class/update`, data);
  }
  deleteClassTutor(id) {
    return axios.get(`tutor/class/delete/${id}`);
  }

  updateClass_Status(data) {
    return axios.post(`tutor/class/update_status`, data);
  }

  createClassLecture(data) {
    return axios.post(`tutor/class/lecture/store`, data);
  }
  uploadvideo(data) {
    return axios.post(`tutor/upload/video`, data, {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    });
  }
  uploadprojectclass(data) {
    return axios.post(`tutor/upload/project`, data, {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    });
  }
  updateClassLecture(data) {
    return axios.post(`tutor/class/lecture/update`, data);
  }
  getClassLecture(id) {
    return axios.get(`tutor/class/lecture/get/${id}`);
  }
  orderbychanges(data) {
    return axios.post(`tutor/class/lecture/order`, data);
  }

  deleteClassTutorLector(id) {
    return axios.get(`tutor/class/lesson/delete/${id}`);
  }
  tutorClassDetails(id) {
    return axios.get(`tutor/class/details/get/${id}`);
  }
  videofilename(id) {
    return axios.get(`tutor/class/details/video/${id}`);
  }
  videofilenameTrainer(id) {
    return axios.get(`tutor/class/details/video/trainer/${id}`);
  }

  admin_getClassDetails(id) {
    return axios.get(`admin/tutors/class/details/get/${id}`);
  }

  tutorProfileDetails() {
    return axios.get(`tutor/profile/get`);
  }

  studentprofiledata() {
    return axios.get(`student/profile/get`);
  }
  CancelStudentPlan() {
    return axios.get(`student/cancel/sub`);
  }
  ResumeStudentPlan() {
    return axios.get(`student/resume/sub`);
  }
  PauseStudentPlan() {
    return axios.get(`student/pause/sub`);
  }
  UpgradeSubpack(data) {
    return axios.post(`student/upgrade/sub`, data);
  }
  studentinvoice(page, pagesize) {
    return axios.get(`student/invoice/get?page=${page}&pagesize=${pagesize}`);
  }
  SubscriptionInvoice(id) {
    return axios.get(`student/subscription/invoices/${id}`);
  }
  SubscriptionHistory() {
    return axios.get(`student/subscription/history`);
  }

  tutorEditProfileDetails() {
    return axios.get(`tutor/profile/edit`);
  }
  tutorProfilePicUpdate(data) {
    return axios.post(`tutor/profile/update/picture`, data);
  }
  deleteProfileImage() {
    return axios.delete('/tutor/profile/profile-image');
  }

  changeTutorPassword(data) {
    return axios.post(`tutor/profile/update/password`, data);
  }
  updateTutorBasicInfo(data) {
    return axios.post(`tutor/profile/update/basic_info`, data);
  }
  updateTutorSocialInfo(data) {
    return axios.post(`tutor/profile/update/social_info`, data);
  }
  updateTutorInvoiceDetails(data) {
    return axios.post(`tutor/profile/update/invoice_details`, data);
  }
  updateTutorSkillInfo(data) {
    return axios.post(`tutor/profile/update/skills_update`, data);
  }

  getSkillCategoryMultiple(CategoryIds) {
    return axios.post(`/tutor/profile/getskillCategory/multipl`, CategoryIds);
  }
  getAllCategoryByMultipleDomainIds(domain_ids) {
    return axios.post(`/tutor/profile/get_category/multipl_domain_ids`, domain_ids);
  }
  gettutorcategoryskills() {
    return axios.get(`/tutor/profile/get_category/skills`);
  }

  getskills() {
    return axios.get(`/getuser_skills`);
  }

  tutorBrowseClass(data) {
    return axios.post(`tutor/browse/class`, data);
  }
  morePopularinstructors(page) {
    return axios.get(`tutor/browse/class/more_popular/instructors/get?page=${page}`);
  }
  morePopularTopicBrowseClasses(page) {
    return axios.get(`tutor/browse/class/more_popular/topic/get?page=${page}`);
  }
  browseClassDetails(id) {
    return axios.get(`tutor/browse/class/details/get/${id}`);
  }
  watchBrowseClassDetails(id) {
    return axios.get(`tutor/browse/class/watch/data/get/${id}`);
  }
  streaming(data) {
    return axios.get(`tutor/browse/class/streaming`, data);
  }
  saveTutorClass(data) {
    return axios.post(`tutor/class/save`, data);
  }
  getMyClass(page, search_key = '', pagesize, status) {
    return axios.get(
      `/tutor/my_class/report/${status}?page=${page}&pagesize=${pagesize}&search=${search_key}`
    );
  }
  AuthorProfilePreview(author_id) {
    return axios.get(`tutor/author/profile/preview/${author_id}`);
  }
  BrowseClassAuthorProfileGetReview(page, author_id) {
    return axios.get(`tutor/author/profile/preview/review/${author_id}?page=${page}`);
  }

  FrontPageAuthorProfilePreview(author_id) {
    return axios.get(`/classtutor/author/profile/preview/${author_id}`);
  }
  FrontPageAuthorProfileGetReview(page, author_id) {
    return axios.get(`/classtutor/author/profile/preview/review/${author_id}?page=${page}`);
  }

  AuthorProfileGetReview(page) {
    return axios.get(`tutor/profile/get_review?page=${page}`);
  }
  classSendForApproval(class_id) {
    return axios.get(`tutor/class/send/approval/${class_id}`);
  }
  getTutotrTicketClass() {
    return axios.get(`tutor/ticket/get_class_all`);
  }
  addTicketNewTutorClass(data) {
    return axios.post(`tutor/ticket/create`, data);
  }
  createClassFaq(data) {
    return axios.post(`tutor/faq/create/store`, data);
  }
  classFaqGet(slug) {
    return axios.get(`tutor/class/faq/get/${slug}`);
  }
  deleteClassTutorFaq(id) {
    return axios.get(`tutor/class/faq/delete/${id}`);
  }
  TrainerDahsboardVideoWatched(fromDate, toDate) {
    return axios.get(`tutor/class/video/watched?from=${fromDate}&to=${toDate}`);
  }
  videoWatchListLogs(class_id, page, pagesize, fromDate, toDate) {
    return axios.get(
      `tutor/class/video/watched/log/${class_id}?page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}`
    );
  }
  videoWatchListLogsStudent(class_id, page, pagesize, fromDate, toDate) {
    return axios.get(
      `tutor/class/video/watched/log/student/${class_id}?page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}`
    );
  }

  //Missing API

  tutorProfileDetailsFrontend(user_id) {
    return axios.get(`/get_tutor_profile_preview/${user_id}`);
  }
  HirePageInstructorProfileGetReview(page, user_id) {
    return axios.get(`/get_tutor_profile_preview/review_get/${user_id}?page=${page}`);
  }

  FrontPageAuthorProfilePreview(author_id) {
    return axios.get(`/classtutor/author/profile/preview/${author_id}`);
  }
  FrontPageAuthorProfileGetReview(page, author_id) {
    return axios.get(`/classtutor/author/profile/preview/review/${author_id}?page=${page}`);
  }

  globleFaqMaster(page, pagesize, search = '') {
    return axios.get(
      `/admin/globle_faq/report?page=${page}&pagesize=${pagesize}&search_key=${search}`
    );
  }
  globleFaqMasterStore(data) {
    return axios.post(`/admin/globle_faq/store`, data);
  }
  globleFaqMasterDelete(id) {
    return axios.get(`/admin/globle_faq/delete/${id}`);
  }
  globleFaqMasterGet() {
    return axios.get(`/admin/globle_faq/master/get`);
  }
  globleFaqDetailStore(data) {
    return axios.post(`/admin/globle_faq_detail/store`, data);
  }
  globleFaqDetailsMaster(id, page, pagesize, search = '') {
    return axios.get(
      `/admin/globle_faq_detail/report/${id}?page=${page}&pagesize=${pagesize}&search_key=${search}`
    );
  }
  globleFaqDetailMasterDelete(id) {
    return axios.get(`/admin/globle_faq_detail/delete/${id}`);
  }
  uploadCategoryBulkStore(data) {
    return axios.post(`/admin/category/bulk_upload/store`, data);
  }

  //lead bulk

  CrossFunctionBulkUpdate(data) {
    return axios.post(`/admin/category/CrossFunctionBulkUpdate/store`, data);
  }
  getAllDomainCategoryUploadBulk() {
    return axios.get(`/admin/domain/bulk_upload_page/get`);
  }
  bulkUploadRecordCategory(page, pagesize, search = '') {
    return axios.get(
      `/admin/category/bulk_upload/report/page?page=${page}&pagesize=${pagesize}&search_key=${search}`
    );
  }
  UpdateCategoryBulkuploadData(data) {
    return axios.post(`/admin/category/bulk_upload/update/changeVariable`, data);
  }
  UpdateCategoryGlobalFaqData(data) {
    return axios.post(`/admin/category/bulk_upload/update/category_global_faq`, data);
  }

  UpdateCategoryGlobalmetaTagData(data) {
    return axios.post(`/admin/category/bulk_upload/update/category_global_metatag`, data);
  }

  getAllInvoiceAndReceipt(
    fromDate,
    toDate,
    page,
    pagesize,
    project_type,
    order_status,
    user_type_status
  ) {
    return axios.get(
      `/admin/account/invoice_report/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&project_type=${project_type}&order_status=${order_status}&user_type=${user_type_status}`
    );
  }

  getGstRefundRecords(fromDate, toDate, page, pagesize) {
    return axios.get(
      `/admin/account/gst_refund_report/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}`
    );
  }
  getInvoiceReport(fromDate, toDate, page, pagesize, project_type, order_status, search_key = '') {
    return axios.get(
      `/admin/report/invoice/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&project_type=${project_type}&order_status=${order_status}&search=${search_key}`
    );
  }
  gettdsReport(fromDate, toDate, page, pagesize, project_type, order_status, search_key = '') {
    return axios.get(
      `/admin/report/tds/${fromDate}/${toDate}?page=${page}&pagesize=${pagesize}&project_type=${project_type}&order_status=${order_status}&search=${search_key}`
    );
  }

  // ============== Social API ==============
  socialNewFeature(fromDate, toDate, page, pagesize) {
    return axios.get(
      `/admin/social/new_feature?page=${page}&pagesize=${pagesize}&from=${fromDate}&to=${toDate}`
    );
  }
  addNewFeature(data) {
    return axios.post(`/admin/social/new_feature/store`, data);
  }
  getSocialNewFeatureEdit(id) {
    return axios.get(`/admin/social/new_feature/edit/${id}`);
  }
  updateSocialNewFeature(data) {
    return axios.post(`/admin/social/new_feature/update/`, data);
  }
  updateStatusSocialNewFeature(id) {
    return axios.get(`/admin/social/new_feature/status/${id}`);
  }
  // ============== Social API ==============

  categoryEmailSendCRM() {
    return axios.get(`/admin/crm/category_send_email`);
  }
  CrmEmailTemplateGet() {
    return axios.get(`/admin/crm/template_email_get`);
  }
  emailSendUserAllGet(type, data) {
    return axios.post(`/admin/crm/send_email_get_users/${type}`, data);
  }
  sendMultpleUsertoEmail(data) {
    return axios.post(`/admin/crm/send_email_to_users`, data);
  }
}
export default new DataService();
